import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Tab, DataDetail, DataTable, DataHead, AiAnalysis, ReportDetail, UserCustomDataTable, StackDetail, SymbolTable, PageTrace,FDInformation
} from 'components/exception/issue';
import { SearchBox, Checkbox, PureRender } from 'components/commons';
import { getIssueDetailUrlPrefix, makeDetailObjectFromStackLine } from 'utils/helper';
import { logOps, levelOps, PLATFORM_ID, levelOpsPc } from 'utils/constants';
import { indexOf } from 'lodash/array';
import _style from './style.scss';
import {
  Tabs,
  Tooltip,
  Modal,
  Spin,
  Select,
  Button,
  notification,
  message,
  Collapse,
  Input,
  Row,
  Col,
  Radio,
  Space, Divider, Popover, Popconfirm, Tag,
} from 'antd';
import axios from 'axios';
import cookie from "../../../../utils/cookie";
import { withTranslation } from 'react-i18next';
import RestHelper from 'utils/RestHelper';
import { connect } from 'react-redux';
import { selectHasSpecifiedPermissionInCurrentApp } from 'utils/selectors/selectors';
import { orange, red } from '@ant-design/colors';
import { CopyOutlined, InfoCircleOutlined, DownloadOutlined  } from '@ant-design/icons';
import {
  isAndroidOrHarmony,
  isMobile,
  isPcOrLinux,
  isPcOrGameConsole,
  isGameConsole,
  PlatformUtil,
  isPlaystation, isAndroid, isSwitch, isMac, isIos, isHarmony,
} from 'utils/platform';
import { PcStackSourceEnum } from 'utils/constants/pc-stack-source-enum';
import { isNotNullish, isNullish } from 'utils/nullish';
import Axios from 'axios';
import MD5 from 'md5.js';
import { UserTypeEnum } from 'utils/constants/user-type-enum';
import { bindActionCreators } from 'redux';
import * as issueActions from 'reducers/issue/issueActions';
import * as globalActions from 'reducers/global/globalActions';
import * as appActions from 'reducers/app/appActions';
import {
  EXCEPTION_TYPE_INT_ANDROID_JAVA,
  ExceptionTypeInt,
  ExceptionTypeName
} from 'utils/constants/exception-type-int';
import IssueSendReportToWorkWeixinModal from 'components/exception/issue/IssueSendReportToWorkWeixinModal';
import { dataComplianceConfirm } from 'utils/dataComplianceConfirm';
import { ze } from 'utils/zhEn';
import { WebAppSettings } from 'utils/web-app-settings';
import { fetchCustomKvConfigForCurrentApp, upsertWebAppSettings } from 'reducers/app/appActions';
import { DataDetailUtil } from 'components/exception/issue/DataDetail';
import { ExceptionCategoryUtil, ExceptionCategory } from 'utils/exception-category';
import { ErrorBoundary } from 'react-error-boundary';
import SameDeviceRelatedReports from 'components/exception/issue/SameDeviceRelatedReports';
import SameLaunchSessionHint from 'components/exception/issue/LastReport/SameLaunchSessionHint';
import CrashAttachmentShowcase from 'components/exception/issue/LastReport/CrashAttachmentShowcase';
import ModuleList from 'components/exception/issue/ModuleList/ModuleList';
import RegisterInfo from 'components/exception/issue/RegisterInfo/RegisterInfo';
import { sleep } from 'utils/sleep';
import reportEvent, { EVENT_ACTIONS } from 'utils/reportEvent';
import CsTabs from 'components/antd-extension/CsTabs';
import CsCollapseButton from 'components/commons/CsCollapseButton/CsCollapseButton';
import { RxCopy, RxShare1 } from "react-icons/rx";
import { RiSendPlaneLine, RiLayoutGridFill } from "react-icons/ri";
import { PiCaretDoubleDownBold, PiCaretDoubleUpBold } from 'react-icons/pi';
import CsDownloadButton from 'components/commons/CsDownloadButton/CsDownloadButton';
import CsSwapSelect from 'components/commons/CsSwapSelect/CsSwapSelect';
import classnames from 'classnames';
import CopyreportIcon from 'svg/v2/newcs_dashboard_crashanalysis_issuedetail_copyreport_icon_normal.svg';
import SharereportIcon from 'svg/v2/newcs_dashboard_crashanalysis_issuedetail_sharereport_icon_normal.svg';
import SendreportIcon from 'svg/v2/newcs_dashboard_crashanalysis_issuedetail_sendreport_icon_normal.svg';
import ViewmoreIcon from 'svg/v2/newcs_dashboard_crashanalysis_issuedetail_viewmore_icon_normal.svg';
import SearchIcon from 'svg/v2/newcs_dashboard_crashanalysis_issuedetail_tracelog_filt_search_icon.svg';
import StackIcon from 'svg/v2/newcs_dashboard_crashanalysis_issuedetail_stack_icon.svg';
import StackSymbolicateModal from './StackSymbolicateModal';
import { CrashAttachmentUtil } from 'utils/crash-attachment-util';
import { ServerAppSettings } from 'utils/server-app-settings';
import WrappedTipsIcon from 'components/antd-extension/WrappedTipsIcon.jsx';
import { ImNewTab } from 'react-icons/im';
import { RetraceHistoryUtil } from 'components/exception/issue/DataHead/RetraceHistoryModal';
import moment from 'moment';
import { CrashModuleUtil } from 'utils/crash-module-util';
import IssueCrashSearchUtil from 'utils/IssueCrashSearchUtil';
import { FieldName, QueryType } from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { patchCurrentIssueInfo } from 'reducers/issue/issueActions';
import JankLinesTable, { JankLinesTableUtil } from 'components/exception/issue/DataDetail/JankLinesTable';
import { CS_STYLES } from 'utils/constants/style-constants';
import { ix } from 'utils/i18n-with-context';
import ReactMarkdown from 'react-markdown';
import gfm from "remark-gfm";
import { downloadAsFile } from 'utils/file-utils';
import CsSimpleButton from 'components/antd-extension/CsSimpleButton';
import DownloadIcon from 'svg/v2/newcs_dashboard_download_icon_normal.svg';
import MallocLogger from 'components/exception/issue/LastReport/MallocLogger';
import GpuCrashInfo from 'components/exception/issue/LastReport/GpuCrashInfo';
import CrashEventTimeline from 'components/exception/issue/LastReport/CrashEventTimeline';
import AllThreadsPanorama from 'components/exception/issue/LastReport/AllThreadsPanorama';
import { CrashUtil } from 'utils/api/crash';

const MINIDUMP_STATUS = {
  PROCESS: 'PROCESS', // 还原中
  SUCCESS: 'SUCCESS', // 还原成功
  FAIL: 'FAIL', // 还原失败
};

const OTHER_THREAD_FILTER_TYPE_CONTAINS = 'OTHER_THREAD_FILTER_TYPE_CONTAINS';
const OTHER_THREAD_FILTER_TYPE_REGEX = 'OTHER_THREAD_FILTER_TYPE_REGEX';

const OtherThreadFilterTypeOptions = [
  { label: ze('包含', 'Contains'), value: OTHER_THREAD_FILTER_TYPE_CONTAINS },
  { label: ze('正则表达式匹配', 'Regexp Match'), value: OTHER_THREAD_FILTER_TYPE_REGEX }
];

@connect((state) => {
  return {
    reduxState: state,
    getHasSpecifiedPermission: (permission) => selectHasSpecifiedPermissionInCurrentApp(state, permission),
  };
}, (dispatch) => ({
  actions: bindActionCreators({
    ...appActions,
    ...globalActions,
    ...issueActions,
    upsertWebAppSettings,
  }, dispatch),
  dispatch,
}))
@withTranslation()
@PureRender
export default class LastReport extends React.Component {
  constructor(props) {
    super(props);
    this.childRef = React.createRef();
    this.isComponentUnmounted = false;
    this.state = {
      retraceLoading: false,

      componentHasError: false,
      isSdkAttachmentsChecked: false,
      hasSdkLogFile: false,
      isSdkLogFileDownloading: false,
      hasSdkAttachFile: false,
      isSdkAttachFileDownloading: false,
      hasSdkScreenshot: false,

      isGenerateShareLinkModalVisible: false,
      shareLinkExpireInDays: 7,
      shareLinkUserRole: UserTypeEnum.COMPLIANCE_MEMBER,

      isIssueSendReportToWorkWeixinModalVisible: false,

      symbolInfoCrashId: '', // symbolInfo和ignoreSymbolInfo对应的crashId，用于拉取前判断是否已经拉取过
      symbolInfoLoading: false,
      symbolInfoList: [],
      ignoreSymbolInfoList: [],

      isSetQuickViewCustomKeyModalVisible: false,
      editingQuickViewCustomKeyList: [],

      isLoadingOtherThread: false,

      isShowAndroidNativeOtherThread: false,

      otherThreadFilterType: OTHER_THREAD_FILTER_TYPE_CONTAINS,
      otherThreadFilterInputValue: '',
      otherThreadIndexToIsCollapsed: {},
      otherThreadViewMode: 'panorama',

      otherThreadFetchedCrashIdKeyMap: {}, // 临时用这个记录一下哪些crash id已经拉取过更多线程信息

      aiAnalysisType: false,//AI分析框是否展示
      isChildMethodExecuting: false,//AI分析按钮状态

      isReportDetailCollapsed: false,
      LogSymbolicateModalVisible: false,
      trackLogViewMode:
        typeof window !== 'undefined' &&
        new URLSearchParams(window.location.search).get('quotedLogInfoBase64')
          ? 'raw'
          : 'timeline',

      retraceStatusQueryResult: null,
      sameLaunchSessionScope: 'all',
    };
  }

  componentDidMount() {
    this.onEffectAppIdChange();
    this.onEffectCrashIdChange();
    this.onEffectFetchSdkAttachmentsStatus();
    this.onEffectFetchPcRegisterInfo();
    this.onEffectFetchRetracedAnrTrace();
    this.onEffectInitLogStatus();
  }

  componentWillUnmount() {
    this.isComponentUnmounted = true;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevCrashId = ((((prevProps.issue && prevProps.issue.toJS()) || {}).crashDoc || {}).crashMap || {}).crashId;
    const nextCrashId = ((((this.props.issue && this.props.issue.toJS()) || {}).crashDoc || {}).crashMap || {}).crashId;
    if (prevCrashId !== nextCrashId && this.state.sameLaunchSessionScope !== 'all') {
      this.setState({ sameLaunchSessionScope: 'all' });
    }
    this.onEffectAppIdChange(prevProps);
    this.onEffectCrashIdChange(prevProps);
    this.onEffectFetchSdkAttachmentsStatus(prevProps);
    this.onEffectFetchPcRegisterInfo(prevProps);
    this.onEffectFetchRetracedAnrTrace(prevProps);
    this.onEffectInitLogStatus(prevProps);
  }

  /**
   * 初始化跟踪日志相关的 redux 状态（logType/logLevel/logKey/stackType/isShowOtherThread）。
   * 这些字段全部由 LastReport 及其子组件专用，因此统一在此处初始化，
   * 避免各调用方重复/遗漏调用。issueId 或 pid 变化时重新初始化。
   */
  onEffectInitLogStatus(prevProps) {
    const { pid, issueId, dispatch } = this.props;
    if (prevProps && prevProps.issueId === issueId && prevProps.pid === pid) return;
    dispatch({ type: 'INIT_LOG_STATUS', logType: PlatformUtil.getDefaultLogType(pid) });
  }

  getServerAppSettings() {
    const { appId, reduxState } = this.props;
    return reduxState.app.get('appIdToServerAppSettings')[appId] || {};
  }

  getIsEnablePcLogTrace() {
    const serverAppSettings = this.getServerAppSettings();
    return serverAppSettings[ServerAppSettings.keys.enablePcLogTrace];
  }

  getIsEnableCrashEventTimeline() {
    const serverAppSettings = this.getServerAppSettings();
    return !!serverAppSettings[ServerAppSettings.keys.enableCrashEventTimeline];
  }

  getIsEnableSmartStackAndThreads() {
    const serverAppSettings = this.getServerAppSettings();
    return !!(
      serverAppSettings[ServerAppSettings.keys.enableIssueOutlierAndVariants] ||
      serverAppSettings[ServerAppSettings.keys.enableCrashEventTimeline]
    );
  }

  getIsEnableSameLaunchSessionHint() {
    const serverAppSettings = this.getServerAppSettings();
    return !!serverAppSettings[ServerAppSettings.keys.enableSameLaunchSessionHint];
  }

  renderSameLaunchSessionHint() {
    if (!this.getIsEnableSameLaunchSessionHint() || this.getIsFromShareLink()) {
      return null;
    }
    const { issue, appId, pid, issueId, reduxState } = this.props;
    const crashMap = (((issue && issue.toJS()) || {}).crashDoc || {}).crashMap || {};
    const utcOffset = reduxState.app.get('current').get('utcOffset');
    return (
      <SameLaunchSessionHint
        appId={appId}
        platformId={pid}
        issueId={issueId}
        crashId={crashMap.crashId}
        deviceId={crashMap.deviceId}
        userId={crashMap.userId}
        utcOffset={utcOffset}
        onOpenSameSession={() => {
          this.setState({ sameLaunchSessionScope: 'same' });
          this.handleChangeTab('LASTREPORT.sameDeviceRelatedReports');
        }}
      />
    );
  }

  getIsEnableErrorRetrace() {
    const serverAppSettings = this.getServerAppSettings();
    return serverAppSettings[ServerAppSettings.keys.enableErrorRetrace];
  }

  getIsEnableDecryptSdkLog() {
    const serverAppSettings = this.getServerAppSettings();
    return !!serverAppSettings[ServerAppSettings.keys.enableDecryptSdkLog];
  }

  getIsEnableUsym() {
    const serverAppSettings = this.getServerAppSettings();
    return !!serverAppSettings[ServerAppSettings.keys.enableUsym];
  }

  getIsAssociateGpuCrashInfoWithError() {
    const serverAppSettings = this.getServerAppSettings();
    return !!serverAppSettings[ServerAppSettings.keys.associateGpuCrashInfoWithError];
  }

  getIsDemoApp() {
    const { reduxState } = this.props;
    return reduxState.app.get('current').get('demoApp');
  }

  getIsFromShareLink() {
    const { shareId } = this.props;
    return !!shareId;
  }

  getCrashIdFromProps(props) {
    if (!props) {
      return null;
    }
    const { crashHash } = props;
    if (!crashHash) {
      return null;
    }
    return crashHash.replace(/:/g, '');
  }

  getCrashIdFromCrashDoc(props) {
    const { issue } = props;
    if (!issue) {
      return undefined;
    }
    const { crashDoc } = issue.toJS();
    const { crashMap } = (crashDoc || {});
    const { crashId } = crashMap || {};
    return crashId;
  }

  getIsIssueExists() {
    const { issue } = this.props;
    const isIssueNotExists = issue?.get('isIssueNotExists');
    return !isIssueNotExists;
  }

  onEffectAppIdChange(prevProps = {}) {
    const appId = this.props.appId;
    const prevAppId = prevProps.appId;
    if (!appId || appId === prevAppId) {
      return;
    }
    const { actions } = this.props;
    if (!this.getIsFromShareLink()) {
      actions.fetchCustomKvConfigForCurrentApp({ skipIfFetched: true });
    }
  }

  onEffectCrashIdChange(prevProps = {}) {
    const crashId = this.getCrashIdFromCrashDoc(this.props);
    const prevCrashId = this.getCrashIdFromCrashDoc(prevProps);
    if (!crashId || crashId === prevCrashId) {
      return;
    }
    this.setState({
      retraceStatusQueryResult: null,
    });
    // 打开问题详情页面，加载重还原状态（用于显示转圈）
    if (!this.getIsFromShareLink()) {
      const { exceptionType } = this.props;
      const shouldAutoRetrace = this.getIsEnableErrorRetrace() && ExceptionCategoryUtil.isError(exceptionType);
      this.pollingRetraceStatus(crashId, {
        delayFirstPolling: false,
        autoRetraceWhenIdle: shouldAutoRetrace,
      });
      this.fetchJankRelatedReports();
      this.saveDataToPermanentStorage(crashId);  // 上报打开之后，调用接口让后台保存数据到永久存储
    }
    this.fetchAttachmentAndOthers();
  }

  async fetchAttachmentAndOthers() {
    const { appId, pid, actions, issue, crashHash, issueId, shareId, exceptionType } = this.props;

    let asyncTasks = [];
    if (PlatformUtil.hasCrashAttachment(pid, exceptionType)) {
      actions.showLoading();
      if (this.getIsFromShareLink()) {
        asyncTasks.push(actions.getCrashAttachmentFromShareLink(appId, pid, shareId));
      } else {
        asyncTasks.push(actions.getCrashAttachment(issueId, crashHash));
      }
    }
    // 拉取PC或者minidump的so info
    asyncTasks.push(this.fetchPcOrMinidumpSoInfo());

    actions.showLoading();
    try {
      await Promise.all(asyncTasks);
    } catch (e) {
      console.error(e);
    } finally {
      actions.hideLoading();
    }

    // 检查拉取附件接口，更多线程等信息是否重还原成功了。如果超时了，就要再拉取一次
    // 来自匿名分享链接的上报目前不支持重试
    if (!this.getIsFromShareLink()) {
      this.checkRetraceResultAndRetryQueryAppDetailCrash();
    }

    // 获取了附件以及minidump的so info之后，才能拉取符号表是否匹配的信息
    await this.cachedFetchSymbolInfoAndIgnoreSymbolInfo();
  }

  // 检查拉取附件接口，更多线程等信息是否重还原成功了。如果超时了，就要再拉取一次
  checkRetraceResultAndRetryQueryAppDetailCrash() {
    const {
      issue,
      crashHash,
      issueId,
      actions,
    } = this.props;
    const issueObj = issue.toJS();
    const { appDetailCrashInfo } = issueObj || {};
    const { retraceTimeout } = appDetailCrashInfo || {};
    if (!retraceTimeout) {
      return;
    }
    actions.getCrashAttachment(issueId, crashHash, { isSecondTry: true });
  }

  // 上报打开之后，调用接口让后台保存数据到永久存储
  // --story=126579553 【CS】上报链接手动打开后不再删除
  async saveDataToPermanentStorage(crashId) {
    const { appId } = this.props;
    await RestHelper.mustPost('/redir/api/data/saveDataToPermanentStorage', { appId, crashId });
  }

  onEffectFetchSdkAttachmentsStatus(prevProps = {}) {
    const { appId } = this.props;
    const crashId = this.getCrashIdFromCrashDoc(this.props);
    const prevCrashId = this.getCrashIdFromCrashDoc(prevProps);
    if (!appId || !crashId) {
      return;
    }
    if (crashId === prevCrashId) {
      return;
    }

    if (!this.state.isSdkAttachmentsChecked) {
      (async () => {
        await this.checkSdkAttachmentsExist();
        this.setState({ isSdkAttachmentsChecked: true });
      })();
    }
  }

  onEffectFetchRetracedAnrTrace(prevProps = {}) {
    const { appId, pid, actions, shareId } = this.props;
    const crashId = this.getCrashIdFromCrashDoc(this.props);
    const prevCrashId = this.getCrashIdFromCrashDoc(prevProps);
    if (!appId || !crashId || crashId === prevCrashId) {
      return;
    }
    actions.fetchCurrentCrashRetracedAnrTrace(shareId);
  }

  async fetchPcOrMinidumpSoInfo() {
    const { pid, actions, shareId } = this.props;

    if (isPcOrLinux(pid) || isPlaystation(pid)) { // PC/linux进来页面就拉取模块信息
      await actions.fetchCurrentCrashPcSoInfo(shareId);
    } else if (isMobile(pid)) { // 移动是看minidump的时候拉取
      let isShowingMinidumpStack = this.props.issue.get('isShowingMinidumpStack');
      if (isShowingMinidumpStack) {
        await actions.fetchCurrentCrashPcSoInfo(shareId);
      }
    }
  }

  onEffectFetchPcRegisterInfo(prevProps = {}) {
    const { appId, pid, actions, shareId } = this.props;
    if (!isPcOrLinux(pid) && !isPlaystation(pid)) {
      return;
    }
    const crashId = this.getCrashIdFromCrashDoc(this.props);
    const prevCrashId = this.getCrashIdFromCrashDoc(prevProps);
    if (!appId || !crashId) {
      return;
    }

    const nowTab2 = this.props.issue.get('tab2');
    const oldTab2 = prevProps.issue && prevProps.issue.get('tab2');
    if (nowTab2 !== 'LASTREPORT.崩溃线程寄存器信息' || (nowTab2 === oldTab2 && crashId === prevCrashId)) {
      return;
    }

    actions.fetchCurrentCrashPcRegisterInfo(shareId);
  }

  static getDerivedStateFromError(error) {
    return { componentHasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('LastReport componentDidCatch: ', error, errorInfo);
  }

  /** 王者卡顿需求：获取原始卡顿相关联的拆分上报，或者拆分上报相关联的原始卡顿 */
  async fetchJankRelatedReports() {
    const {
      appId,
      pid: platformId,
      issue,
      actions,
    } = this.props;
    const { crashDoc } = issue.toJS();
    const esMap = crashDoc.esMap || {};
    const { expUid, crashExceptionType, crashId } = esMap;
    if (ExceptionCategoryUtil.fromExceptionTypeInt(crashExceptionType) !== ExceptionCategory.JANK) {
      return;
    }

    if (!expUid) {
      message.error('Invalid report, expUid is empty.');
      return;
    }

    const rsp = await RestHelper.mustPost('/api/crash/queryCrashList', {
      appId,
      platformId,
      start: 0,
      rows: 100,
      needEsMapList: true,
      needRetracedStack: true, // 火焰图信息是从堆栈取的
      searchConditionGroup: {
        conditions: [{
          field: FieldName.expUid,
          queryType: QueryType.TERM,
          term: expUid,
        }],
      },
    });
    let jankRelatedReportEsMapList = (rsp.json.ret.esMapList || [])
      .filter(esMap => esMap.crashId !== crashId)
      .map(esMap => {
        const crashMap = rsp.json.ret.crashDatas[esMap.crashId];
        const { jankFlameGraphJson } = crashMap || {};
        return {
          ...esMap,
          jankFlameGraphJson,
        };
      });

    const crashIdToLastAvg = {};
    jankRelatedReportEsMapList.forEach(esMap => {
      const reservedMapStr = esMap?.reservedMapStr;
      const jankMetricLineList = JankLinesTableUtil.parseJankMetricLineList(reservedMapStr);
      const lastAvg = jankMetricLineList[jankMetricLineList.length - 1]?.avg || 0;
      crashIdToLastAvg[esMap.crashId] = lastAvg;
    });
    // 按照lastAvg排序
    jankRelatedReportEsMapList.sort((a, b) => {
      const aLastAvg = crashIdToLastAvg[a.crashId] || 0;
      const bLastAvg = crashIdToLastAvg[b.crashId] || 0;
      return bLastAvg - aLastAvg;
    });

    actions.patchCurrentIssueInfo({
      jankRelatedReportEsMapList,
    });
  }

  // 获取页面追踪数据
  getPageTraceContent() {
    const { issue } = this.props;
    const { attachList } = issue.toJS();

    if (!attachList) {
      return '';
    }
    let contents = '';
    attachList.forEach((item) => {
      if (item.fileName === 'martianlog.txt') {
        contents += item.content;
      }
    });
    return contents;
  }

  makeStackLineDetailObjectList(stackContent) {
    const { pid } = this.props;
    const stackLines = stackContent.split('\n');
    return stackLines.map((stackLine, i) => {
      return makeDetailObjectFromStackLine(stackLine, 'crash', pid);
    }).filter(x => x.line);
  };

  getIosExtraStackThreads() {
    const { issue } = this.props;
    const { appDetailCrashInfo } = issue.toJS();
    if (!appDetailCrashInfo) {
      return null;
    }
    const extraStackThreadNames = (appDetailCrashInfo.stackName || '').split(';')
      .filter(x => x)
      .sort((a, b) => a.localeCompare(b));
    if (extraStackThreadNames.length === 0) {
      return null;
    }

    return extraStackThreadNames.map(threadName => {
      const attachment = appDetailCrashInfo.attachList.find(x => x.fileName === threadName && Number(x.fileType) === 2);
      const attachmentContent = (attachment || {}).content;
      if (!attachmentContent) {
        return { name: threadName, isPresent: false, stackLineDetailObject: {} };
      }
      const stackLineDetailObject = this.makeStackLineDetailObjectList(attachment.content);
      return { name: threadName, isPresent: true, stackLineDetailObject };
    });
  }



  handleChangeTab(key) {
    const {
      dispatch,
    } = this.props;
    dispatch({
      type: 'CHANGE_TAB',
      value: key,
      tab: '2',
    });
  }

  async checkSdkAttachmentsExist() {
    const { appId, issue } = this.props;
    const { crashDoc } = issue.toJS();
    const crashMap = crashDoc.crashMap || {};
    const { crashId } = crashMap;
    if (!appId || !crashId || this.getIsFromShareLink()) {
      this.setState({ hasSdkLogFile: false, hasSdkAttachFile: false, hasSdkScreenshot: false });
      return;
    }
    try {
      const rsp = await RestHelper.mustPost('/redir/api/data/querySdkAttachmentsUploadStatus', {
        appId,
        partialCrashMap: CrashAttachmentUtil.makePartialCrashMapForSdkUploadedFile(crashMap),
      });
      const { hasSdkLog, hasSdkAttach, hasSdkScreenshot } = rsp.json.data || {};
      this.setState({
        hasSdkLogFile: !!hasSdkLog,
        hasSdkAttachFile: !!hasSdkAttach,
        hasSdkScreenshot: !!hasSdkScreenshot,
      });
    } catch (e) {
      this.setState({ hasSdkLogFile: false, hasSdkAttachFile: false, hasSdkScreenshot: false });
    }
  }

  async downloadSdkLog(filename) {
    if (this.getIsEnableDecryptSdkLog()) {
      return this.downloadDecryptedSdkLog(filename);
    }

    const { appId, issue } = this.props;
    const { crashDoc } = issue.toJS();
    const crashMap = crashDoc.crashMap || {};
    const { expUid } = crashMap;

    this.setState({ isSdkLogFileDownloading: true });
    message.info(ze('下载中，请稍候', 'Downloading.'));
    try {
      const rsp = await RestHelper.mustPost('/redir/api/data/fetchSdkUploadedAttachments', {
        appId,
        partialCrashMapList: [CrashAttachmentUtil.makePartialCrashMapForSdkUploadedFile(crashMap)],
        attachmentFilenameList: ['SDK_LOG'],
      });
      const { crashIdAndAttachmentsList } = rsp.json.data;
      const attachment = crashIdAndAttachmentsList?.[0]?.attachments?.[0];
      if (!attachment) {
        message.error('No attachment found');
        return;
      }
      const { content: contentBase64 } = attachment;
      const uint8Array = Uint8Array.from(window.atob(contentBase64), c => c.charCodeAt(0));
      downloadAsFile(`${expUid}_${filename}`, uint8Array);
      message.success(ze('已成功下载', 'File downloaded successfully.'));
    } catch (e) {
      message.error('Parse file failed. Please contact customer service.');
    } finally {
      this.setState({ isSdkLogFileDownloading: false });
    }
  }

  // （NGR需求）项目上传的SDK log是否有内部中间件加密，下载的时候需要解密
  async downloadDecryptedSdkLog(filename) {
    const { appId, issue } = this.props;
    const { crashDoc } = issue.toJS();
    const esMap = crashDoc.esMap || {};
    const { expUid, crashId } = esMap;
    const rsp = await RestHelper.mustPost('/redir/api/data/fetchNGRDecodedAttachments', {
      appId,
      crashIdList: [crashId],
      attachmentFilenameList: ['SDK_LOG'],
    })
    const { crashIdAndAttachmentsList } = rsp.json.data;
    const attachment = crashIdAndAttachmentsList?.[0]?.attachments?.[0];
    if (!attachment) {
      message.error('No attachment found');
      return;
    }
    const { content: contentBase64 } = attachment;
    try {
      const uint8Array = Uint8Array.from(window.atob(contentBase64), c => c.charCodeAt(0));
      downloadAsFile(`${expUid}_${filename}`, uint8Array);
      message.success(ze('已成功下载', 'File downloaded successfully.'));
    } catch (e) {
      message.error('Parse file failed. Please contact customer service.');
    }
  }

  async downloadSdkAttach(filename) {
    const { appId, issue } = this.props;
    const { crashDoc } = issue.toJS();
    const crashMap = crashDoc.crashMap || {};
    const { expUid } = crashMap;

    this.setState({ isSdkAttachFileDownloading: true });
    message.info(ze('下载中，请稍候', 'Downloading.'));
    try {
      const rsp = await RestHelper.mustPost('/redir/api/data/fetchSdkUploadedAttachments', {
        appId,
        partialCrashMapList: [CrashAttachmentUtil.makePartialCrashMapForSdkUploadedFile(crashMap)],
        attachmentFilenameList: ['SDK_ATTACH'],
      });
      const { crashIdAndAttachmentsList } = rsp.json.data;
      const attachment = crashIdAndAttachmentsList?.[0]?.attachments?.[0];
      if (!attachment) {
        message.error('No attachment found');
        return;
      }
      const { content: contentBase64 } = attachment;
      const uint8Array = Uint8Array.from(window.atob(contentBase64), c => c.charCodeAt(0));
      downloadAsFile(`${expUid}_${filename}`, uint8Array);
      message.success(ze('已成功下载', 'File downloaded successfully.'));
    } catch (e) {
      message.error('Parse file failed. Please contact customer service.');
    } finally {
      this.setState({ isSdkAttachFileDownloading: false });
    }
  }

  handleLogTypeSelectChange(value) {
    const { changeLog, issueId } = this.props;
    changeLog(value, issueId);
  }

  handleLogLevelSelectChange(value) {
    const { changeLevel, issueId } = this.props;
    changeLevel(value, issueId);
  }

  handleKeywordChange(value) {
    const { changeLogKey, issueId } = this.props;
    changeLogKey(value, issueId);
  }

  handleSymbolicateClick() {
    this.setState({ LogSymbolicateModalVisible: true });
  }

  handleDownloadClick(issue,hasNoSystemLog,pid) {
    const {
      sysLogs, userLogs, logType,
    } = issue.toJS();
    let log = [];
    if (logType === 'userLog') {
      log = userLogs;
    } else if (logType === 'sysLog' && sysLogs && !hasNoSystemLog) {
      log = sysLogs;
    }
    const sequences = log.join('\n');
    const blob = new Blob([sequences], { type: 'text/plain;charset=utf-8' });

    // 使用file-saver库保存Blob对象为.txt文件
    saveAs(blob, logType === 'userLog' ? 'CustomLog.txt' : 'SystemLog.txt');
    reportEvent({
      action: EVENT_ACTIONS.CLICK,
      tp1: '跟踪日志-数据下载',
    });
  }

  // 功能：还原和解析功能以及重还原功能。
  async handleStackTypeClick(stackType) {
    // 重还原的接口在这里添加，添加重还原功能。发起重还原请求。
    const { dispatch, issueId, appId, issue, crashHash } = this.props;
    const {exceptionName, crashDoc } = issue.toJS();
    const crashMap = crashDoc.crashMap || {};

    if (stackType === 'retraceAgain') {
      this.handleReloadCrash('retraceAgain');
      // TODO: 确认重还原接口的逻辑，重新发起请求，添加loading状态。
      // actions.showLoading();
      // actions.getCrashAttachment(issueId, crashHash).then(actions.hideLoading).catch(actions.hideLoading);
    } else if (stackType === 'retraceMinidump') {
      this.handleReloadCrash('retraceMinidump');
    } else if (stackType === 'aiParsing') {
      this.setState({aiAnalysisType:true},async() => {
        if(this.childRef.current){
          this.setState({ isChildMethodExecuting: true });
          await this.childRef.current.childMethod();
          this.setState({ isChildMethodExecuting: false });
        }
      })
    } else {
      dispatch({
        type: 'STACK_TYPE_CHANGE',
        issueId,
        stackType,
      });
    }
  }

  /**
   * 切换其他线程项的显示/隐藏
   */
  handleToggleOtherThreadItem(index) {
    this.setState({
      otherThreadIndexToIsCollapsed: {
        ...this.state.otherThreadIndexToIsCollapsed,
        [index]: !this.state.otherThreadIndexToIsCollapsed[index],
      },
    });
  }

  /*
   收起，打开其他线程,会在这一步开始去请求其它线程的数据信息;如果attachList已经存在，则显示其它线程的请求已经发起过了，这一步就不再去做请求了。
   */
  async handleOtherThreadClick() {
    const {
      dispatch, issue, actions, crashHash, issueId,
      shareId,
      pid,
    } = this.props;
    const {
      isShowOtherThread,
      attachList,
      isShowingMinidumpStack,
      androidNativeOtherThreadAttachInfoList
    } = issue.toJS();
    // 默认先关闭
    dispatch({
      type: 'IS_SHOW_OTHER_THREAD',
      isShow: !isShowOtherThread,
    });

    const hasAndroidNativeOtherThread = !isShowingMinidumpStack && androidNativeOtherThreadAttachInfoList?.length > 0;
    // 安卓如果有native更多线程，默认显示native
    this.setState({ isShowAndroidNativeOtherThread: hasAndroidNativeOtherThread });

    if (!issueId || !crashHash) {
      return;
    }

    this.setState({
      otherThreadFetchedCrashIdKeyMap: {
        ...this.state.otherThreadFetchedCrashIdKeyMap,
        [crashHash]: true,
      },
    });

    const needFetch = isPcOrLinux(pid) || isPlaystation(pid)
      ? !isShowOtherThread && !this.state.otherThreadFetchedCrashIdKeyMap[crashHash]
      : !isShowOtherThread && !attachList;

    if (needFetch) {
      await this.fetchOtherThreads();
    }
  }

  async fetchOtherThreads() {
    const {
      appId,
      dispatch, issue, actions, crashHash, issueId,
      shareId,
      pid,
    } = this.props;

    try {
      this.setState({ isLoadingOtherThread: true });
      actions.showLoading();
      if (PlatformUtil.isMobileOrMobileLike(pid)) {
        if (this.getIsFromShareLink()) {
          await actions.getCrashAttachmentFromShareLink(appId, pid, shareId);
        } else {
          await actions.getCrashAttachment(issueId, crashHash);
        }
      } else if (isPcOrLinux(pid) || isPlaystation(pid)) {
        await this.fetchPcOrLinuxOtherThreads();
      }
    } finally {
      this.setState({ isLoadingOtherThread: false });
      actions.hideLoading();
    }
  }

  // 拉取PC、linux、PS5的更多线程
  async fetchPcOrLinuxOtherThreads() {
    const { dispatch, issue, appId, pid: platformId, shareId } = this.props;
    const { crashDoc } = issue.toJS();
    const esMap = crashDoc.esMap || {};
    let { otherBreakpadCosKey } = esMap;
    if (!otherBreakpadCosKey) {
      message.info(ze('当前上报没有其他线程信息。', 'This report has no other threads info.'));
      return;
    }
    if (isPcOrLinux(platformId) && !otherBreakpadCosKey.endsWith('.dmp.gz')) {
      otherBreakpadCosKey = otherBreakpadCosKey + '.dmp.gz';
    }
    const rsp = await RestHelper.post('/api/crash/decompressInflateFile', {
      appId,
      platformId,
      shareId,
      cosKey: otherBreakpadCosKey,
      compressFormat: 'GZIP',
    });
    const { hasFile, contentBase64 } = rsp.json.data;
    if (hasFile) {
      const uint8Array = Uint8Array.from(window.atob(contentBase64), c => c.charCodeAt(0));
      const otherThreadsText = new TextDecoder().decode(uint8Array);
      dispatch({
        type: 'PARSE_AND_SAVE_PC_OTHER_THREADS',
        payload: {
          otherThreadsText,
          // PS5其他线程文件格式与PC/Linux不同，解析时需要通过平台区分。
          platformId,
        },
      });
    } else {
      message.info(ze('当前上报没有其他线程信息。', 'This report has no other threads info.'));
    }
  }

  // 新的重还原请求接口
  async handleReloadCrash(type) {
    const {
      appId, pid: platformId, issueId, crashHash, user,
      exceptionType,
      actions,
    } = this.props;

    const crashId = this.getCrashIdFromProps(this.props);

    const isRetraceMinidump = type === 'retraceMinidump';
    let retraceType = undefined;
    if (isRetraceMinidump) {
      retraceType = exceptionType === 'crash' || exceptionType === 'crashes'
        ? 'MINIDUMP_CRASH'
        : 'MINIDUMP_ERROR';
    }

    this.setState({ retraceLoading: true });
    const rsp = await RestHelper.mustPost('/api/issue/reRetraceCrash', {
      appId,
      platformId,
      issueId,
      crashDataType: 'ReloadCrash',
      crashHash: crashId,
      requestLocalUserId: user.get('newUserId'), // 用于帮助定位重还原问题，增加重还原的请求人
      requestUserName: user.get('nickname'),
      retraceType,
    });

    await this.pollingRetraceStatus(crashId, {
      delayFirstPolling: true,
      autoRetraceWhenIdle: false,
    });
    if (isRetraceMinidump) {
      this.setState({ retraceLoading: true });
      await sleep(30000); // ES分片数据同步不是立刻的，要拿minidump还原状态要等30秒以上
      this.setState({ retraceLoading: false });
    }
    this.reloadCrashDataAfterPollingRetraceStatus(type);
  }

  async pollingRetraceStatus(crashId, options = {}) {
    if (!crashId) {
      return;
    }
    const {
      delayFirstPolling = false,
      autoRetraceWhenIdle = false,
    } = options;
    
    const {
      appId, pid: platformId, issueId, crashHash, user,
    } = this.props;

    const POLLING_INTERVAL_MS = 5000;
    const MAX_TRY = 300;
    let tryCount = 0;
    let retraceStatus = 0;
    for (; tryCount < MAX_TRY; tryCount += 1) {
      if (delayFirstPolling) {
        await sleep(POLLING_INTERVAL_MS);
      }

      // 如果切换了查看的上报，或者关闭了LastReport（例如更多上报点击了其他的上报），那么停止轮询
      if (this.isComponentUnmounted) {
        return;
      }
      const currentPageCrashId = this.getCrashIdFromProps(this.props);
      if (currentPageCrashId !== crashId) {
        return;
      }

      retraceStatus = await this.handleReloadCrashStatus();
      
      // 如果是第一次查询且设置了自动重还原，检查是否需要触发自动重还原（retraceStatus为nullish代表未执行过重还原）
      if (tryCount === 0 && autoRetraceWhenIdle && isNullish(retraceStatus)) {
        // 重还原状态为0（未在进行中），触发自动重还原
        this.handleStackTypeClick('retraceAgain');
        return;
      }
      
      if (isNullish(retraceStatus) || retraceStatus <= 0) {
        return;
      }

      if (!delayFirstPolling) {
        await sleep(POLLING_INTERVAL_MS);
      }
    }

    // 超过重试次数，报错并return
    if (tryCount === MAX_TRY) {
      notification.error({
        message: ze('重还原请求超时', 'Re-symbolication Timeout'),
        description: ze('请稍后重试，或联系客服反馈问题。', 'Please try again later or contact customer service for assistance.'),
        duration: 30,
      });
      throw Error('Re-symbolication Timeout');
    }

    // 小于0代表出现服务器端错误，报错并return
    if (retraceStatus < 0) {
      notification.error({
        message: ze('重还原失败', 'Re-symbolication Failed'),
        description: ze('服务器发生错误。请稍后重试，或联系客服反馈问题。', 'A server error occurred. Please try again later or contact customer service for assistance.'),
        duration: 30,
      });
      throw Error('Re-symbolication Failed');
    }
  }

  // 重还原完成，刷新最新异常堆栈和其他线程的堆栈
  async reloadCrashDataAfterPollingRetraceStatus(type) {
    const {
      appId, pid: platformId, issueId, crashHash, user,
      exceptionType,
      actions,
    } = this.props;

    const isRetraceMinidump = type === 'retraceMinidump';

    const crashId = this.getCrashIdFromProps(this.props);
    await actions.getCrashDoc(issueId, crashId);
    await this.fetchOtherThreads();
    await this.onChangeStackTraceType(isRetraceMinidump);
    const { crashDoc } = this.props.issue.toJS();
    const { esMap, crashMap } = crashDoc || {};
    const {
      retraceResultInfo,
      minidumpParseStatus,
      minidumpParseFailReason,
      appSoNameList,
    } = esMap || {};


    let retraceType = undefined;
    if (isRetraceMinidump) {
      retraceType = exceptionType === 'crash' || exceptionType === 'crashes'
        ? 'MINIDUMP_CRASH'
        : 'MINIDUMP_ERROR';
    }

    if (!isRetraceMinidump) { // 非minidump
      const { systemSoNameList } = crashMap || {};
      const lowerSystemSoNameList = (systemSoNameList || []).map(x => (x || '').toLowerCase());
      const lowerAppSoNameList = (appSoNameList || []).map(x => (x || '').toLowerCase());

      const failedSoNames = Object.entries(retraceResultInfo || {})
        .filter(([k, v]) => !CrashModuleUtil.getIsSystemModule(k, lowerSystemSoNameList, lowerAppSoNameList) && v)
        .map(([k, v]) => k);

      if (failedSoNames.length === 0) {
        notification.success({
          message: ze('重还原已执行，堆栈内容已刷新', 'Re-symbolication done, stack trace have been updated.'),
          duration: 10,
        });
      } else {
        notification.warning({
          message: ze('重还原已执行，堆栈内容已刷新。', 'Re-symbolication done, stack trace have been updated.'),
          description: <div>
            <div>{ze('以下模块还原失败：', 'The following modules failed to re-symbolicate.')}</div>
            {failedSoNames.map((x, i) => <div key={i}>{x}</div>)}
          </div>,
          duration: 30,
        });
      }
    } else { // minidump
      if (minidumpParseStatus !== MINIDUMP_STATUS.FAIL) {
        notification.success({
          message: ze('重还原已执行，堆栈内容已刷新', 'Re-symbolication done, stack trace have been updated.'),
          duration: 10,
        });
      } else {
        notification.warning({
          message: ze('重还原失败', 'Re-symbolication failed'),
          description: ze(`错误码：${minidumpParseFailReason}`, `Error code = ${minidumpParseFailReason}`),
          duration: 30,
        });
      }
    }
  }

  // 查询重还原状态
  async handleReloadCrashStatus() {
    const {
      issue, appId, pid,issueId
    } = this.props;
    const crashId = this.getCrashIdFromCrashDoc(this.props);
    if (!crashId) {
      return;
    }
    const rsp = await RestHelper.post('/redir/api/issue/queryRetraceStatus', {
      appId,
      issueId,
      crashId,
    });

    const data = rsp.json.data;
    const retraceStatusQueryResult = {
      ...data,
      lastRetraceStartTime: data.lastRetraceStartTime && moment(data.lastRetraceStartTime).format('YYYY-MM-DD HH:mm:ss'),
      lastRetraceEndTime: data.lastRetraceEndTime && moment(data.lastRetraceEndTime).format('YYYY-MM-DD HH:mm:ss'),
    };
    const { retraceStatus } = retraceStatusQueryResult;

    this.setState({
      retraceLoading: RetraceHistoryUtil.getIsRetraceProcessing(retraceStatus),
      retraceStatusQueryResult,
    });
    return retraceStatus;
  }

  async cachedFetchSymbolInfoAndIgnoreSymbolInfo(forceFetch = false) {
    if (this.getIsFromShareLink()) {
      return;
    }
    const enableUsym = this.getIsEnableUsym();
    const {
      appId, pid, issue,
    } = this.props;
    const { attachList, crashDoc, pcModuleInfoList, attachAllKvList } = issue.toJS();
    const { crashMap, esMap } = (crashDoc || {});
    const { crashId } = crashMap;
    if (crashId === this.state.symbolInfoCrashId && !forceFetch) {
      return;
    }

    const version = crashMap.productVersion || 'NO_VERSION';
    let uuids = CrashUtil.getSymbolUuidList({ pid, crashDoc, attachList, pcModuleInfoList, attachAllKvList, enableUsym });

    this.setState({
      symbolInfoLoading: true,
    });
    const uuidQuery = uuids.filter(x => x).join(',') || '-1';
    const [symbolRsp, ignoreRsp] = await Promise.all([
      RestHelper.post(`/redir/api/symbol/queryIssueSymbolInfo`, {
        appId,
        version,
        uuid: uuidQuery,
      }),
      RestHelper.get(`/getIgnoreSymbol/appId/${appId}/platformId/${pid}`),
    ]);
    this.setState({
      symbolInfoCrashId: crashId,
      symbolInfoList: symbolRsp.json.data,
      ignoreSymbolInfoList: ignoreRsp.json.ret.data,
      symbolInfoLoading: false,
    });
  }


  handleCloseClick() {
    const { closeCrashItem } = this.props;
    // //默认先关闭
    // dispatch({
    //  type: 'IS_SHOW_CRASHITEM',
    //  value: '-1'
    // });
    closeCrashItem();
  }

  /**
   * 从crashDoc/detailMap/attachName 字符串里面判断是否有某个字段
   * @param attachName {string}
   * @return {object}
   */
  hasAttachFile(attachName, filename) {
    return typeof attachName === 'string' && attachName.indexOf(filename) > -1;
  }

  async copyUrlToClipboard(text) {
    const { t } = this.props;
    try {
      await navigator.clipboard.writeText(text);
      message.success(t('LASTREPORT.已复制链接至剪贴板'));
    } catch (e) {
      notification.error({ message: 'Failed to copy text to clipboard.' });
    }
    reportEvent({
      action: EVENT_ACTIONS.CLICK,
      tp1: '复制链接',
    });
  }

  async generateReportShareLink() {
    const { appId, pid: platformId, issueId, issue } = this.props;
    const { crashDoc } = issue.toJS();
    const { crashId } = crashDoc.crashMap || {};
    const { shareLinkExpireInDays, shareLinkUserRole } = this.state;

    const rsp = await RestHelper.mustPost('/api/issue/generateReportShareLink', {
      appId,
      platformId,
      issueId,
      crashId,
      expireInSeconds: shareLinkExpireInDays * 86400,
      equivalentUserRole: shareLinkUserRole,
    });
    const { shareId } = rsp.json.data;
    const shareLink = `${window.location.origin}/shared-report/${shareId}`;
    Modal.success({
      width: '800px',
      closable: true,
      okText: ze('复制链接', 'Copy Link'),
      onOk: () => this.copyUrlToClipboard(shareLink),
      content: <div>
        <div>{ze('已生成分享链接：', 'The sharing link has been generated:')}</div>
        <div style={{ marginTop: '8px' }}>
          <Input
            style={{ width: '680px' }}
            readOnly
            value={shareLink}
          />
        </div>
      </div>,
    });
  }

  /** 王者卡顿，从拆分后卡顿跳转到原始 */
  async redirectToJankRawReport() {
    const {
      appId,
      pid: platformId,
      issue,
      exceptionType,
    } = this.props;
    const { crashDoc } = issue.toJS();
    const esMap = crashDoc.esMap || {};
    const { expUid } = esMap;
    if (!expUid) {
      message.error(ze('未找到原始卡顿', 'Failed to find the original jank.'));
      return;
    }

    const rsp = await RestHelper.mustPost('/api/crash/queryCrashList', {
      appId,
      platformId,
      start: 0,
      rows: 10,
      searchConditionGroup: {
        conditions: [{
          field: FieldName.expUid,
          queryType: QueryType.TERM,
          term: expUid,
        }, {
          field: FieldName.exceptionType,
          queryType: QueryType.TERM,
          term: ExceptionTypeName.JankRaw,
        }],
      },
    });

    const crashDataList = Object.values(rsp.json.ret.crashDatas || {});
    if (crashDataList.length === 0) {
      message.error(ze('未找到原始卡顿', 'Failed to find the original jank.'));
      return;
    }

    const crashData = crashDataList[0];
    const {
      crashId,
      issueId,
    } = crashData;
    const path = `/${getIssueDetailUrlPrefix(exceptionType)}/${appId}/${issueId}/report-id/${crashId}?pid=${platformId}`;
    window.open(path, '_blank');
  }

  renderTop(exceptionType, appId, pid, issueId, crashId, crashDataType) {
    const {
      isReport,
      isIssueRegroup,
      getHasSpecifiedPermission,
      reduxState,
    } = this.props;
    const isInTencentLocalNetwork = reduxState.user.get('isInTencentLocalNetwork');
    const allowGenerateShareLink = getHasSpecifiedPermission('VIEW_DETAIL');

    if (isIssueRegroup) {
      return null;
    }

    const issueDetailUrlPrefix = getIssueDetailUrlPrefix(exceptionType);
    const { isLastReport, t } = this.props;
    const notLastReportNotice = t("LASTREPORT.notLastReportNotice")
      .split(/<a>(.*?)<\/a>/)
      .map((x, i) => i % 2
        ? <Link to={`/${issueDetailUrlPrefix}/${appId}/${issueId}?pid=${pid}`}>{x}</Link>
        : <span>{x}</span>);

    const reportPageUrl = `${window.location.origin}/${issueDetailUrlPrefix}/${appId}/${issueId}/report-id/${crashId}?pid=${pid}`;

    return (
      <div className={_style.title}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          { !isReport && isLastReport && <span className={_style.lastReportPrefix}>{ t("LASTREPORT.title") }</span> }
          <span className={_style.crashId}>
            { t("LASTREPORT.postId") }
            {crashId}
          </span>
          { !this.getIsFromShareLink() && <Button
            onClick={() => { this.copyUrlToClipboard(reportPageUrl) }}
            type='link'
            style={{ marginLeft: '40px', padding: 0 }}
          ><div
            className={_style.IconHover}
            style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <CopyreportIcon />
            <div>{ t('LASTREPORT.复制本条异常上报的链接') }</div>
          </div></Button> }
          { !this.getIsDemoApp() && !this.getIsFromShareLink() && allowGenerateShareLink && <Button
            onClick={() => {
              this.setState({ isGenerateShareLinkModalVisible: true });
            }}
            type='link'
            style={{ marginLeft: '24px', padding: 0 }}
          ><div
            className={_style.IconHover}
            style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <SharereportIcon />
            <div>{ t('LASTREPORT.生成匿名访问链接') }</div>
          </div></Button> }
          { !this.getIsDemoApp() && !this.getIsFromShareLink() && isInTencentLocalNetwork && <Button
            onClick={async() => {
              await dataComplianceConfirm();
              this.setState({ isIssueSendReportToWorkWeixinModalVisible: true } );
            }}
            type='link'
            style={{ marginLeft: '24px', padding: 0 }}
          ><div
            className={_style.IconHover}
            style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <SendreportIcon/>
            <div>{ t('LASTREPORT.分享此上报至企业微信/钉钉/飞书/Slack') }</div>
          </div></Button>}

          { !this.getIsDemoApp() && !this.getIsFromShareLink() && isReport && <Button
            type='link'
            style={{ marginLeft: '24px', padding: 0 }}
          ><a href={reportPageUrl} target="_blank" rel="noopener noreferrer"><div
            className={_style.IconHover}
            style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <ImNewTab />
            <div>{ ze('在新页面打开', 'Open in New Tab') }</div>
          </div></a></Button> }

          <div style={{ flexGrow: 1 }} />
          { this.getIsIssueExists() && !isReport && <Link to={`/${issueDetailUrlPrefix}/${appId}/${issueId}/report?pid=${pid}&crashDataType=${crashDataType}`}>
            <div
              className={_style.IconHover}
              style={{ display: 'flex', alignItems: 'center', gap: '2px', marginRight:'10px' }}>
              <ViewmoreIcon/>
              <span className={`${_style.link}`}>{ t("LASTREPORT.checkMore") }</span>
            </div>
          </Link> }
          { !isReport && <CsCollapseButton
            style={{ marginLeft: '20px' }}
            isCollapsed={this.state.isReportDetailCollapsed}
            onClick={() => this.setState({ isReportDetailCollapsed: !this.state.isReportDetailCollapsed })}
          /> }
        </div>
        { !isReport && !isLastReport && <div className={_style.notLastReportNoticeBlock}>{ notLastReportNotice }</div> }
      </div>
    );
  }

  async onChangeStackTraceType(v) {
    const { actions, t, shareId } = this.props;
    actions.patchCurrentIssueInfo({ isShowingMinidumpStack: v });
    if (v) {
      await Promise.all([
        actions.fetchCurrentCrashMinidumpStack(shareId),
        actions.fetchCurrentCrashPcRegisterInfo(shareId),
        actions.fetchCurrentCrashPcSoInfo(shareId),
      ]);
      await this.cachedFetchSymbolInfoAndIgnoreSymbolInfo(true); // minidump的匹配符号表信息需要额外拉取一下
    }
  }

  renderStackTraceTypeSwapSelect() {
    const { actions, t, shareId } = this.props;
    let { crashDoc, isShowingMinidumpStack, minidumpStackInfo } = this.props.issue.toJS();
    const esMap = (crashDoc || {}).esMap || {};
    const {
      crashId,
      hasMinidump,
      minidumpParseStatus,
      minidumpParseFailReason,
    } = esMap;
    if (shareId || !hasMinidump) {
      return null;
    }

    const isMinidumpOptionAvailable = minidumpParseStatus === MINIDUMP_STATUS.SUCCESS;

    const clientStackTraceOption = { value: 0, label: t('LASTREPORT.切换服务器回溯堆栈') };
    const serverStackTraceOption = { value: 1, label: t('LASTREPORT.切换客户端回溯堆栈') };

    const swapSelect = <div><CsSwapSelect
      options={[clientStackTraceOption, serverStackTraceOption]}
      value={Number(!!isShowingMinidumpStack)}
      onChange={async (v) => {
        if (v && !isMinidumpOptionAvailable) {
          return;
        }
        this.onChangeStackTraceType(!!v);
      }}
    /></div>;

    let res = swapSelect;
    if (minidumpParseStatus === MINIDUMP_STATUS.PROCESS) {
      res = <Tooltip
        title={ze('正在处理服务器回溯堆栈。', 'The minidump re-symbolication is processing.')}
      >{ swapSelect }</Tooltip>;
    } else if (minidumpParseStatus === MINIDUMP_STATUS.FAIL) {
      res = <Tooltip
        title={ze(`服务器回溯堆栈失败，失败原因：${minidumpParseFailReason}`, `Minidump re-symbolication failed, error code: ${minidumpParseFailReason}`)}
      >{ swapSelect }</Tooltip>;
    } else if (!isMinidumpOptionAvailable) {
      res = <Popconfirm
        title={ <div style={{ width: '300px' }}>{ ze('此上报尚未执行过服务器侧堆栈还原。是否要以Minidump方式在服务器侧还原堆栈？还原后即可查看服务器回溯堆栈相关信息。', 'The report has not yet been symbolicated server side stack trace. Do you want to symbolicate server side stack trace in the form of a minidump? After the symbolication, you will be able to view the relevant information of the serverside stack trace.') }</div> }
        onConfirm={() => this.handleStackTypeClick('retraceMinidump')}
      >{ swapSelect }</Popconfirm>
    }

    return res;
  }

  /**
   * 渲染出错堆栈Tab的内容
   */
  renderErrorStackTab() {
    const {
      issue, appId, pid, exceptionType, user, stackLineDetailObjectList, isIssueRegroup, actions, shareId, t
    } = this.props;

    let {
      exceptionName, keyStack, stackType, isShowOtherThread, crashDoc,
      issueExceptionType,
      isShowingMinidumpStack,
      jankSampleStackInfo,
    } = issue.toJS();

    let exceptionMessage = issue.get('exceptionMessage');
    let threadName = '';
    let retraceState = 0;
    let hasPcLinuxBreakpadStack = false;
    if (crashDoc && crashDoc.crashMap) {
      threadName = crashDoc.crashMap.threadName;
      exceptionName = crashDoc.crashMap.expName || exceptionName;
      exceptionMessage = crashDoc.crashMap.expMessage;
      retraceState = crashDoc.crashMap.retraceStatus;
      hasPcLinuxBreakpadStack = !!crashDoc.crashMap.linuxBreakpadStack;
    }

    const stackTraceTypeSwapSelect = this.renderStackTraceTypeSwapSelect();

    const isJank = ExceptionCategoryUtil.isJank(exceptionType);
    const isJankRaw = Number(issueExceptionType) === ExceptionTypeInt.JankRaw;

    // 卡顿采样堆栈（jankV2_samples.json）：只要上报带有该附件，就用它替代原有的"其他线程"入口和内容区
    const hasJankSampleStack = !isIssueRegroup && jankSampleStackInfo?.samples?.length > 0;

    // 只有移动端、PC/Linux（不限异常大类）、PS5（仅崩溃、卡死）有其他线程
    const hasOtherThreadButton = !hasJankSampleStack
      && !isIssueRegroup
      && !isJank
      && (PlatformUtil.isMobileOrMobileLike(pid) || isPcOrLinux(pid) || (isPlaystation(pid) && (ExceptionCategoryUtil.isCrash(exceptionType) || ExceptionCategoryUtil.isHang(exceptionType))));

    let threadNameLabel = `${t('REPORTDETAIL.异常线程')}: `;
    const containerCode = (
       <div className={_style.data_container}>
        <div>
          <div className={`${_style.data_item}`}>
            <DataHead
              isMainThread={true}
              retraceLoading={this.state.retraceLoading}
              retraceStatusQueryResult={this.state.retraceStatusQueryResult}
              handleStackTypeClick={(e) => this.handleStackTypeClick(e)}
              stackTraceTypeSwapSelect={stackTraceTypeSwapSelect}
              style={_style}
              {...{
                exceptionName,
                keyStack,
                exceptionMessage,
                stackType,
                pid,
                threadName,
                issue,
                exceptionType,
                user,
                threadNameLabel,
                isIssueRegroup,
                actions,
                shareId,
                symbolInfoLoading: this.state.symbolInfoLoading,
                symbolInfoList: this.state.symbolInfoList,
                isChildMethodExecuting: this.state.isChildMethodExecuting,
                onClickRedirectToJankRawReport: this.redirectToJankRawReport.bind(this),
              }} />
              {this.state.aiAnalysisType &&
              <AiAnalysis
                ref={this.childRef}
                {...{
                  appId,
                  issue
                }}
              />}
            { isPcOrLinux(pid) && hasPcLinuxBreakpadStack && <div style={{ fontSize: '16px' }}>WinDbg Stack:</div> }
            <DataDetail
              {...{
                isShowingMinidumpStack,
                issue,
                appId,
                pid,
                exceptionType,
                dataType: 'stack',
                style: _style,
                stackLineDetailObjectList,
                symbolInfoLoading: this.state.symbolInfoLoading,
                symbolInfoList: this.state.symbolInfoList,
                ignoreSymbolInfoList: this.state.ignoreSymbolInfoList,
              }}
            />
            { isPcOrLinux(pid) && hasPcLinuxBreakpadStack && <div style={{ fontSize: '16px' }}>Breakpad Stack:</div> }
            { isPcOrLinux(pid) && hasPcLinuxBreakpadStack && <DataDetail
              {...{
                issue,
                appId,
                pid,
                exceptionType,
                dataType: 'stack',
                style: _style,
                stackLineDetailObjectList,
                pcStackSource: PcStackSourceEnum.LINUX_BREAKPAD,
              }}
            /> }
          </div>
        </div>
        <Spin spinning={this.state.isLoadingOtherThread}>
          {
          // 有卡顿采样堆栈附件时，用"展开/收起卡顿采样堆栈"入口替代原有的"其他线程"入口；
          // 两者互斥，只有移动端、PC（仅崩溃）有其他线程
          (hasOtherThreadButton || hasJankSampleStack) && (
            <div className={_style.otherThreadButtonArea}>
              {isShowOtherThread
                ? <a className={classnames(_style.otherThreadButton, _style.expanded)} onClick={() => this.handleOtherThreadClick()}><PiCaretDoubleUpBold/><div>{ this.props.t(hasJankSampleStack ? "ERRORSTACKTAB.collapseJankSample" : "ERRORSTACKTAB.collapse") }</div></a>
                : <a className={classnames(_style.otherThreadButton, _style.collapsed)} onClick={() => this.handleOtherThreadClick()}><PiCaretDoubleDownBold/><div>{ this.props.t(hasJankSampleStack ? "ERRORSTACKTAB.expandJankSample" : "ERRORSTACKTAB.expand") }</div></a>
              }
            </div>
          )
        }
          {isShowOtherThread
            ? (hasJankSampleStack ? this.renderJankSampleStack(jankSampleStackInfo) : this.renderOtherThread(issue, pid, threadName))
            : null}
        </Spin>
        { isJank && <div> {
          this.renderJankRelatedReports()
        } </div> }
      </div>
    );

    return (
      <div>
        {this.renderSameLaunchSessionHint()}
        {containerCode}
      </div>
    )
  }

  renderJankRelatedReports() {
    const {
      issue, appId, pid, exceptionType, user, stackLineDetailObjectList, isIssueRegroup, actions, shareId, t,
    } = this.props;
    const {
      issueExceptionType,
      jankRelatedReportEsMapList,
    } = issue.toJS();

    const isJankParsed = Number(issueExceptionType) === ExceptionTypeInt.JankParsed;

    const tableList = (jankRelatedReportEsMapList || [])
      .filter(esMap => esMap.crashExceptionType === ExceptionTypeInt.JankParsed)
      .map((esMap, i) => {
        const { crashIssueId: issueId, crashId } = esMap;
        const url = `/${getIssueDetailUrlPrefix(exceptionType)}/${appId}/${issueId}/report-id/${crashId}?pid=${pid}`;

        return <div
          key={i}
          style={{ marginTop: '16px' }}
        >
          <Divider/>
          <div style={{ marginBottom: '8px' }}>{ isJankParsed && '其他相关' }拆分后上报： #<Link to={url} target='_blank' rel="noopener noreferrer">{ crashId }</Link></div>
          <JankLinesTable
            crashEsMap={esMap}
          />
        </div>;
      });
    return tableList;
  }

  /**
   * 渲染 其他信息, 控制台信息， anr其他信息
   */
  renderOtherMsg(dataType, supportStackTraceTypeRadioGroup) {
    const { issue, appId, pid, exceptionType } = this.props;
    return <div>
      <div style={{ display: 'flex', justifyContent: 'end' }}>{ this.renderStackTraceTypeSwapSelect() }</div>
      <div className={_style.data_container} style={{ marginTop: '12px' }}>
        <div className={`${_style.data_item} marginbottom20`}>
          <DataDetail
            {...{ issue, appId, pid, exceptionType, dataType, style: _style }}
          />
        </div>
      </div>
    </div>;
  }

  renderModuleList() {
    const { issue, appId, pid, exceptionType } = this.props;
    return <div>
      <div style={{ display: 'flex', justifyContent: 'end' }}>{ this.renderStackTraceTypeSwapSelect() }</div>
      <div className={_style.data_container}>
        <div className={`${_style.data_item} marginbottom20`}>
          <ModuleList
            pid={pid}
            issue={issue}
          />
        </div>
      </div>
    </div>;
  }

  renderRegisterInfo() {
    const { issue, appId, pid, exceptionType } = this.props;
    return <div>
      <div style={{ display: 'flex', justifyContent: 'end' }}>{ this.renderStackTraceTypeSwapSelect() }</div>
      <div className={_style.data_container} style={{ marginTop: '12px' }}>
        <div className={`${_style.data_item} marginbottom20`}>
          <ErrorBoundary
            fallback={<div style={{ color: 'red', fontSize: '14px' }}>Error occurred during rendering register info.</div>}
          >
            <RegisterInfo
              pid={pid}
              issue={issue}
            />
          </ErrorBoundary>
        </div>
      </div>
    </div>;
  }

  renderMallocLogger() {
    const { pid, issue } = this.props;
    const { crashLogData } = issue.get('appDetailCrashInfo');
    return <div>
      <div className={_style.data_container} style={{ marginTop: '12px' }}>
        <div className={`${_style.data_item} marginbottom20`}>
          <ErrorBoundary
            fallback={<div style={{ color: 'red', fontSize: '14px' }}>Error occurred during rendering malloc logger.</div>}
          >
            <MallocLogger
              pid={pid}
              issue={issue}
              crashLogData={crashLogData}
            />
          </ErrorBoundary>
        </div>
      </div>
    </div>;
  }

  /*
    渲染FD信息
  */
  renderFDTab() {
    const { issue, appId, pid, exceptionType } = this.props;
    return (
      <div className={_style.data_container}>
        <div className={`${_style.data_item} marginbottom20`}>
        <ErrorBoundary fallback={<div style={{ color: 'red',fontSize:'14px',textAlign:'center' }}>
          {ze('渲染出错，请联系管理员','Render error, please contact administrator.')}
        </div>}>
          <FDInformation
            {...{ issue, appId, pid, exceptionType }}
          />
        </ErrorBoundary>
        </div>
      </div>
    );
  }


  /**
   * 渲染符号表Tab的内容
   */
  renderSymbolTab() {
    const { style, issue, appId, pid } = this.props;
    const { symbolInfoList, ignoreSymbolInfoList, symbolInfoLoading } = this.state;
    return <Spin spinning={symbolInfoLoading}><div style={{ position: 'relative' }}>
      <div style={{ position: 'absolute', right: 0, top: '-4px' }}>{ this.renderStackTraceTypeSwapSelect() }</div>
      <SymbolTable
        style={style}
        issue={issue}
        appId={appId}
        pid={pid}
        symbolInfo={symbolInfoList}
        ignoreSymbolInfo={ignoreSymbolInfoList}
        fetchSymbolInfoAndIgnoreSymbolInfo={() => this.cachedFetchSymbolInfoAndIgnoreSymbolInfo(true)}
        goSymbolTag={(...params) => this.handleChangeTab(...params)}
      />
    </div></Spin>;
  }

  /*
   渲染出错堆栈，跟踪数据，跟踪日志tab
   */

  renderDataTab() {
    const { issue, pid } = this.props;
    const showDivider = issue.get('tab2') && issue.get('tab2') !== 'LASTREPORT.errorStack' && issue.get('tab2') !== 'LASTREPORT.gpuStack';
    return <div style={{ padding: '0 8px' }}>
      { showDivider && <Divider style={{ margin: '16px 0' }}/> }
      { this.renderDataTabContent() }
    </div>;
  }

  renderDataTabContent() {
    const { issue, pid } = this.props;
    switch (issue.get('tab2')) {
      case 'LASTREPORT.附件下载':
        return this.renderCrashAttachmentShowcase();
      case 'LASTREPORT.trackData':
        return this.renderTrackDataTab();
      case 'LASTREPORT.gpuStack':
        return this.renderGpuStackDataTab();
      case 'LASTREPORT.trackLog':
        return this.renderTrackLogTab();
      case 'LASTREPORT.symbol':
        return this.renderSymbolTab();
      case 'LASTREPORT.anrMsg':
        return this.renderOtherMsg('anrMessage');
      case 'LASTREPORT.anrTrace':
        return this.renderOtherMsg('anrTrace');
      case 'LASTREPORT.mallocLogger': {
        return this.renderMallocLogger();
      }
      case 'LASTREPORT.崩溃线程寄存器信息': {
        return this.renderRegisterInfo();
      }
      case 'LASTREPORT.加载模块信息': {
        return this.renderModuleList();
      }
      case 'LASTREPORT.FD信息': {
        return this.renderFDTab();
      }
      case 'LASTREPORT.consoleInfo':
        return this.renderOtherMsg('consolelog');
      case 'LASTREPORT.memoryLog':
        return this.renderOtherMsg('meminfo');
      case 'LASTREPORT.otherInfo': {
        const dataType = parseInt(pid) === PLATFORM_ID.ANDROID ? 'crashInfos' : 'otherMsg';
        return this.renderOtherMsg(dataType);
      }
      case 'LASTREPORT.sameDeviceRelatedReports': {
        return this.renderSameDeviceRelatedReports();
      }
      case 'LASTREPORT.errorStack':
      default:
        return this.renderErrorStackTab();
    }
    return null;
  }

  getTagContentForLogType(pid, logType) {
    if (logType === 'userLog') {
      return 'PrintLog';
    } else if (isAndroid(pid)) {
      return 'Logcat';
    } else if (PlatformUtil.isIosOrMac(pid)) {
      return 'NSLog';
    } else if (isHarmony(pid)) {
      return 'HiLog';
    } else {
      return ze('不支持', 'Not Available');
    }
  }

  /**
   * 渲染跟踪日志Tab的内容
   */
  renderTrackLogTab() {
    const { issue, appId, pid, exceptionType, t } = this.props;
    const issueJs = issue ? issue.toJS() : {};
    const { logLevel, logType, logKey, sysLogs, userLogs, attachList, crashDoc } = issueJs;
    const esMap = (crashDoc || {}).esMap || {};
    const requirePermissionLogOps = ['userLog'];
    const hasPermission = this.hasViewPersonalDataPermission();
    const hasNoSystemLog = !PlatformUtil.isSystemLogEnabled(pid);
    const hasLogLevel = PlatformUtil.isLogLevelEnabled(pid, logType);
    // 不支持 System Log 的平台：sysLog 选项禁用，且默认选中 userLog（由 initLogStatus 保证）
    const filterLogOps = logOps.map(({ label, value }) => {
      const disabledByPermission = !hasPermission && requirePermissionLogOps.includes(value);
      const disabledByPlatform = hasNoSystemLog && value === 'sysLog';
      const disabled = disabledByPermission || disabledByPlatform;
      const tagContent = this.getTagContentForLogType(pid, value);

      let labelDom;
      if (disabledByPermission) {
        labelDom = `${label} (${t('common.无权限')})`;
      } else if (disabledByPlatform) {
        labelDom = `${label} (${ze('不支持', 'Not Available')})`;
      } else {
        labelDom = <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div>{ label }</div>
          { tagContent && <Tag color='geekblue'>{ tagContent }</Tag> }
        </div>
      }

      return {
        label: labelDom,
        value,
        disabled,
      };
    });
    const supportTimeline =
      this.getIsEnableCrashEventTimeline() && (isAndroid(pid) || isPcOrLinux(pid));
    const viewMode = supportTimeline ? this.state.trackLogViewMode || 'timeline' : 'raw';
    const hasTimeLevel = isPcOrLinux(pid)
      ? PlatformUtil.isLogLevelEnabled(pid, 'userLog')
      : PlatformUtil.isLogLevelEnabled(pid, 'sysLog');
    const showLevelSelect = viewMode === 'timeline' ? hasTimeLevel : hasLogLevel;
    return (
      <div className={_style.data_container}>
        {this.renderSameLaunchSessionHint()}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
          {supportTimeline && (
            <Radio.Group
              data-testid="track-log-view-mode"
              value={viewMode}
              onChange={(e) => this.setState({ trackLogViewMode: e.target.value })}
            >
              <Radio.Button value="timeline">
                {ze('⚡ 崩溃前事件时间轴', '⚡ Crash Timeline')}
              </Radio.Button>
              <Radio.Button value="raw">
                {ze('原始日志', 'Raw Log')}
              </Radio.Button>
            </Radio.Group>
          )}
          {viewMode === 'raw' && (
            <Select
              style={{ width: '200px' }}
              options={filterLogOps}
              value={logType}
              onChange={(v) => this.handleLogTypeSelectChange(v)}
            />
          )}
          { showLevelSelect && <Select
            style={{ width: '200px' }}
            options={isPcOrLinux(pid) ? levelOpsPc : levelOps}
            value={logLevel}
            onChange={(v) => this.handleLogLevelSelectChange(v)}
          /> }
          <Input
            style={{ width: '320px' }}
            prefix={<SearchIcon />}
            onChange={(e) => this.handleKeywordChange(e.target.value)}
          />
          {this.getIsEnablePcLogTrace() && <Button
            onClick={() => this.handleSymbolicateClick()}
          >
            {ze('还原', 'Symbolicate')}
          </Button>}
          <div style={{ flex: 1 }}/>
          <CsDownloadButton
            onClick={() => this.handleDownloadClick(issue,hasNoSystemLog,pid)}
          />
        </div>
        <div className={_style.data_item}>
          {viewMode === 'timeline' ? (
            <CrashEventTimeline
              pid={pid}
              sysLogs={sysLogs}
              userLogs={userLogs}
              attachList={attachList}
              allowSysLog={!hasNoSystemLog}
              allowUserLog={!!hasPermission}
              crashTime={esMap.crashTime}
              logLevel={showLevelSelect ? logLevel : 'verbose'}
              logKey={logKey}
              expName={esMap.expName}
              expMessage={esMap.expMessage}
            />
          ) : (
            <DataDetail
              {...{
                issue,
                appId,
                pid,
                exceptionType,
                dataType: 'log',
                style: _style,
                logType,
              }}
            />
          )}
        </div>
      </div>
    );
  }

  renderCrashAttachmentShowcase() {
    return <div className={_style.data_container}>
      <CrashAttachmentShowcase
        hasSdkLogFile={this.state.hasSdkLogFile}
        hasSdkAttachFile={this.state.hasSdkAttachFile}
        onClickDownloadSdkLogFile={(filename) => this.downloadSdkLog(filename)}
        onClickDownloadSdkAttachFile={(filename) => this.downloadSdkAttach(filename)}
      />
    </div>;
  }

  renderGpuStackDataTab() {
    const { issue } = this.props;
    return <div>
      <div className={_style.data_container} style={{ marginTop: '12px' }}>
        <div className={`${_style.data_item} marginbottom20`}>
          <ErrorBoundary
            fallback={<div style={{ color: 'red', fontSize: '14px' }}>Error occurred during rendering GPU Crash Infos.</div>}
          >
            <GpuCrashInfo
              issue={issue}
              pid={this.props.pid}
            />
          </ErrorBoundary>
        </div>
      </div>
    </div>;
  }

  /**
   * 渲染跟踪数据Tab的内容
   */
  renderTrackDataTab() {
    const {
      issue, appId, pid, style, exceptionType,
      t,
      shareId,
      shareLinkEquivalentUserPermissions,
      reduxState,
    } = this.props;
    const { crashDoc } = issue.toJS();
    const crashMap = (crashDoc || {}).crashMap || {};
    const { deviceId, bucketPath } = crashMap;
    const mobile = PlatformUtil.isMobileOrMobileLike(pid);
    const contents = this.getPageTraceContent();

    return (
      <div>
        { !isGameConsole(pid) && <div className={_style.data_container}>
          <p className={style.subtitle}>{ this.props.t("TRACKDATATAB.baseData") }</p>
          <div className={_style.data_item}>
            <DataTable
              style={_style}
              {...{ appId, pid, issue, exceptionType, shareId, shareLinkEquivalentUserPermissions }}
            />
          </div>
        </div> }

        <div className={_style.data_container}>
          <div className={style.subtitle}><Space>
            <div>{ t("TRACKDATATAB.customData") }</div>
          </Space></div>
        </div>


        <div className={_style.data_container}>
        <p className={style.subtitle}>{ '' }</p>
          <div className={_style.data_item}>
            <UserCustomDataTable
              shareId={shareId}
              issue={issue}
              pid={pid}
              style={_style}
            />
          </div>
        </div>

        { mobile && contents && (
          <div className={_style.data_container}>
            <p className={style.subtitle}>{ this.props.t("TRACKDATATAB.pageTrack") }</p>

            <div className={_style.data_item}>
              <PageTrace contents={contents} />
            </div>
          </div>
        )}
      </div>
    );
  }

  /*
    出错堆栈展示额外堆栈信息
    2025-02-20：老的逻辑，已经废弃，和崩溃的统一合并
  */
  additionalStackInformation(){
    const { pid, style, issue } = this.props;
    const iosExtraStackThreads = this.getIosExtraStackThreads() || [];
    return ( <div style={{margin:'10px 0'}}>
      <p className={style.subtitle}>{ this.props.t("TRACKDATATAB.extraStack") }</p>
      <div className={_style.data_item}>
        <Collapse>{
          iosExtraStackThreads.map(({ name, isPresent, stackLineDetailObject }, i) => {
            const panelHeader = `Thread # ${name}`;
            if (!isPresent) {
              return <Collapse.Panel key={i} header={panelHeader}>
                <div>Attachment is empty.</div>
              </Collapse.Panel>;
            }
            return <Collapse.Panel key={i} header={panelHeader}>
              <DataDetail
                issue={issue}
                pid={pid}
                dataType='stack'
                style={_style}
                exceptionType='crash'
                isRetracedStack={false}
                stackLineDetailObjectList={stackLineDetailObject}
              />
            </Collapse.Panel>;
          })
        }</Collapse>
      </div>
    </div>)
  }

  /*
   渲染其他线程
   */
  renderOtherThread(currentIssue, pid, reportThreadName) {
    const {
      user,
      isIssueRegroup,
      actions,
      shareId,
      exceptionType,
      t,
      issue,
    } = this.props;
    const {
      issueExceptionType,
      otherThread,
      androidNativeOtherThreadAttachInfoList,
      hasAndroidTraceOtherThreads,
      minidumpStackInfo,
      isShowingMinidumpStack,
      appDetailCrashInfo,
    } = currentIssue.toJS();
    const { retraceTimeout } = appDetailCrashInfo || {};

    const { crashDoc } = issue ? issue.toJS() : {};
    const crashMap = (crashDoc || {}).crashMap || {};
    const { crashId } = crashMap;

    const hasAndroidNativeOtherThread = isAndroid(pid)
      && !isShowingMinidumpStack
      && androidNativeOtherThreadAttachInfoList?.length > 0;

    const showAndroidNativeOtherThreadHint = isAndroid(pid)
      && !isShowingMinidumpStack
      && Number(issueExceptionType) === ExceptionTypeInt.Native
      && !hasAndroidNativeOtherThread;

    const downloadAsTxt = (data, crashMap) => {
      const filename = `${ze('其他线程', 'Other Threads')}_${crashId}.txt`;
      let txtContent = '';

      const { retraceCrashDetail, threadName } = crashMap;
      const cleanedThreadName = threadName.trim();

      if (retraceCrashDetail) {
        const cleanedRetraceCrashDetail = retraceCrashDetail
          .split('\n') // 按行分割
          .map(line => line.replace(/^\s+/, '')) // 去除行首空白字符（包括 \t 和空格）
          .join('\n'); // 重新拼接成字符串
        txtContent += `${t('REPORTDETAIL.线程名')}: ${threadName} (${t('REPORTDETAIL.异常线程')})\n`;
        txtContent += `\n${cleanedRetraceCrashDetail}\n\n`;
      }

      data.forEach(item => {
        const itemThreadName = (item.fileName || '').trim();
        // 处理 content，去除每行开头的 \t 或空格
        const cleanedContent = item.content
          .split('\n') // 按行分割
          .map(line => line.replace(/^\s+/, '')) // 去除行首空白字符（包括 \t 和空格）
          .join('\n'); // 重新拼接成字符串

        // 如果线程名和异常线程的线程名一样，则跳过
        if (itemThreadName === cleanedThreadName) {
          return;
        }

        txtContent += `${t('REPORTDETAIL.线程名')}: ${itemThreadName}\n`;
        txtContent += `\n${cleanedContent}\n\n`;
      });

      downloadAsFile(filename, txtContent);
    };

    const { minidumpOtherThreadInfoList } = minidumpStackInfo || {};
    const currentShowingThreadInfoList = isShowingMinidumpStack
      ? minidumpOtherThreadInfoList
      : (this.state.isShowAndroidNativeOtherThread ? androidNativeOtherThreadAttachInfoList : otherThread);
    const enableSmartStackAndThreads = this.getIsEnableSmartStackAndThreads();

    const renderSingleThreadCard = (thread, index, isCollapsed, onToggleCollapse) => {
      const threadNameLabel = `${t('REPORTDETAIL.线程名')}:`;
      const thisThreadName = thread.fileName;
      return (
        <div
          className={`${_style.data_item} ${isCollapsed ? 'unactive' : ''}`}
          key={`otherStack-${index}`}
        >
          <DataHead
            isMainThread={false}
            isCollapsed={isCollapsed}
            style={_style}
            threadName={thisThreadName}
            threadNameLabel={threadNameLabel}
            otherThreadExtraInfo={thread.otherThreadExtraInfo}
            onClick={onToggleCollapse}
            pid={pid}
            stackContent={thread.content}
            isIssueRegroup={isIssueRegroup}
            actions={actions}
            user={user}
            exceptionType={exceptionType}
            shareId={shareId}
            handleStackTypeClick={(e) => this.handleStackTypeClick(e)}
            hideReretraceButton={index > 0}
          />
          <StackDetail
            issue={currentIssue}
            stackContent={thread.content}
            isNeedHighLight
            pid={pid}
            enableSmartStack={enableSmartStackAndThreads}
          />
        </div>
      );
    };

    let threads = [];
    if (Array.isArray(currentShowingThreadInfoList)) {
      threads = currentShowingThreadInfoList.map((thread, index) => {
        const isCollapsed = !!this.state.otherThreadIndexToIsCollapsed[index];
        const thisThreadName = thread.fileName;
        // 过滤掉和异常线程名字一样的其他线程。 iOS有bug，异常线程名字后面多了空格所以trim掉
        if (reportThreadName && thisThreadName && String(reportThreadName).trim() === String(thisThreadName).trim()) {
          return null;
        }

        return (
          <div key={`otherStackWrap-${index}`} className="marginbottom20">
            {renderSingleThreadCard(thread, index, isCollapsed, () =>
              this.handleToggleOtherThreadItem(index)
            )}
          </div>
        );
      }).filter(x => x);
    }
    const isPanoramaActive =
      enableSmartStackAndThreads && this.state.otherThreadViewMode === 'panorama';

    return <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        { enableSmartStackAndThreads && threads.length > 0 && (
          <Radio.Group
            size="small"
            value={this.state.otherThreadViewMode}
            onChange={(e) => this.setState({ otherThreadViewMode: e.target.value })}
          >
            <Radio.Button value="panorama">
              {ze('🧭 全线程并发全景', '🧭 Concurrency Panorama')}
            </Radio.Button>
            <Radio.Button value="classic">
              {ze('📋 经典列表', '📋 Classic List')}
            </Radio.Button>
          </Radio.Group>
        ) }
        { !isPanoramaActive && threads.length > 0 && <>
          <div>{ ze('按指定堆栈关键字折叠线程：', 'Collapse threads with stack keyword: ') }</div>
          <Select
            style={{ width: '160px' }}
            value={this.state.otherThreadFilterType}
            options={OtherThreadFilterTypeOptions}
            onChange={v => this.setState({ otherThreadFilterType: v })}
          />
          <Input
            style={{ width: '240px' }}
            value={this.state.otherThreadFilterInputValue}
            onChange={e => this.setState({ otherThreadFilterInputValue: e.target.value })}
          />
          <Button
            onClick={() => this.onClickCollapseOtherThreadsByFilter(currentIssue)}
          >{ ze('执行', 'Run') }</Button>
          <Button
            onClick={() => this.onClickExpandAllOtherThreads()}
          >{ ze('展开全部线程', 'Expand All Threads') }</Button>
        </> }
        <div style={{ flexGrow: 1 }}/>
        { hasAndroidNativeOtherThread && <Radio.Group
          size="small"
          value={Number(this.state.isShowAndroidNativeOtherThread)}
          onChange={(e) => {
            this.setState({
              isShowAndroidNativeOtherThread: !!e.target.value,
              otherThreadIndexToIsCollapsed: {},
            })
          }}
        >
          <Radio value={0}>{ ze('Java线程', 'Java Threads') }</Radio>
          <Radio value={1}>{ ze(hasAndroidTraceOtherThreads ? '来自Trace的线程' : 'Native线程', 'Native Threads') }</Radio>
        </Radio.Group> }
        {threads.length > 0 && <Tooltip
          title={ze('导出其他线程堆栈', 'Export other thread stacks')}
        >
          <CsSimpleButton
            style={{marginRight:'10px'}}
            onClick={() => downloadAsTxt(currentShowingThreadInfoList, crashMap)}
          >
            <DownloadIcon/>
          </CsSimpleButton>
        </Tooltip>}
      </div>
      { threads.length > 0 && showAndroidNativeOtherThreadHint && <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '4px', color: CS_STYLES.PRIMARY_COLOR_ORANGE }}>
        <WrappedTipsIcon />
        <div>{ ze('需要开启全线程堆栈功能（SDK版本4.3.7以上）或者minidump（SDK版本4.2.14以上）来获取native堆栈。', 'Full thread stack trace (SDK version 4.3.7 or above) or minidump (SDK version 4.2.14 or above) is required to obtain native stack.') }</div>
      </div>}
      { retraceTimeout && <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '4px', color: CS_STYLES.PRIMARY_COLOR_ORANGE }}>
        <WrappedTipsIcon />
        <div>{ ze('其他线程堆栈正在还原中，请稍候。', 'Other thread stack is being symbolicating, please wait.') }</div>
      </div>}
      { isPanoramaActive && threads.length > 0 ? (
        <AllThreadsPanorama
          threads={currentShowingThreadInfoList}
          reportThreadName={reportThreadName}
          renderThreadItem={renderSingleThreadCard}
        />
      ) : (
        threads
      ) }
    </div>;
  }

  /*
   渲染卡顿采样堆栈（jankV2_samples.json）。
   卡顿期间对某个线程做了多次采样，采样点已经按堆栈内容group by成samples数组，
   这里按每组采样点里最新的时间戳倒序平铺展示，数量过多（超过100组）时默认逐项折叠，避免一次性撑开页面。
   */
  renderJankSampleStack(jankSampleStackInfo) {
    const {
      user, isIssueRegroup, actions, shareId, exceptionType, issue, pid,
    } = this.props;
    const { threadId, samples } = jankSampleStackInfo || {};

    // 每组采样点取最大时间戳用于排序，最新的排最上面。
    // 用reduce而不是Math.max(...times)，避免单组采样点数量很多时参数展开导致调用栈溢出
    const sortedSamples = [...(samples || [])]
      .map((sample) => ({
        ...sample,
        _maxTime: (sample.times || []).reduce((max, t) => Math.max(max, t), 0),
      }))
      .sort((a, b) => b._maxTime - a._maxTime);

    const items = sortedSamples.map((sample, index) => {
      const { stack, times, _maxTime } = sample;
      // 数量过多时默认折叠，避免一次性渲染的堆栈把页面撑得太长
      const defaultCollapsed = sortedSamples.length > 100;
      const isCollapsed = index in this.state.otherThreadIndexToIsCollapsed
        ? !!this.state.otherThreadIndexToIsCollapsed[index]
        : defaultCollapsed;

      const sortedTimes = [...(times || [])].sort((a, b) => a - b);
      const minTime = sortedTimes[0];
      const maxTime = sortedTimes[sortedTimes.length - 1] ?? _maxTime;
      const timeRangeText = minTime && maxTime
        ? `${moment(minTime).format('HH:mm:ss.SSS')} ~ ${moment(maxTime).format('HH:mm:ss.SSS')}`
        : '';
      // 标题用"采样次数 + 时间范围"代替原有更多线程的"线程名：XXX"
      const threadNameLabel = `${ze('采样', 'Sampled')} `;
      const thisThreadName = `${(times || []).length} ${ze('次', 'time(s)')} · ${timeRangeText}`;

      return (<div key={`jankSampleStack-${index}`}>
        <div className={`${_style.data_item} marginbottom20 ${isCollapsed ? 'unactive' : ''}`}>
          <DataHead
            isMainThread={false}
            isCollapsed={isCollapsed}
            style={_style}
            threadName={thisThreadName}
            threadNameLabel={threadNameLabel}
            // 注意：不能直接复用 handleToggleOtherThreadItem——它是基于 state 里的原始值取反，
            // 而这里展示的isCollapsed在没有手动切换过时会用defaultCollapsed兜底，
            // 两者不一致会导致数量超过100条默认折叠时，第一次点击展开没有反应，需要基于当前实际展示的isCollapsed取反
            onClick={() => this.setState({
              otherThreadIndexToIsCollapsed: {
                ...this.state.otherThreadIndexToIsCollapsed,
                [index]: !isCollapsed,
              },
            })}
            pid={pid}
            stackContent={stack}
            isIssueRegroup={isIssueRegroup}
            actions={actions}
            user={user}
            exceptionType={exceptionType}
            shareId={shareId}
            handleStackTypeClick={(e) => this.handleStackTypeClick(e)}
            hideReretraceButton={index > 0}
          />
          <StackDetail
            issue={issue}
            stackContent={stack}
            isNeedHighLight
            pid={pid}
            // 卡顿采样堆栈内容本身已经带有行号（如"#00"），不需要再叠加这里自动生成的序号
            hideAutoLineNumber
          />
        </div>
      </div>);
    });

    return <div>
      { threadId && <div style={{ marginBottom: '12px' }}>{ ze(`线程ID：${threadId}`, `Thread ID: ${threadId}`) }</div> }
      { items }
    </div>;
  }

  onClickCollapseOtherThreadsByFilter(currentIssue) {
    const keyword = (this.state.otherThreadFilterInputValue || '').trim();
    if (!keyword) {
      return;
    }

    const {
      otherThread,
      androidNativeOtherThreadAttachInfoList,
      minidumpStackInfo,
      isShowingMinidumpStack,
    } = currentIssue.toJS();
    const { minidumpOtherThreadInfoList } = minidumpStackInfo || {};
    const currentShowingThreadInfoList = isShowingMinidumpStack
      ? minidumpOtherThreadInfoList
      : (this.state.isShowAndroidNativeOtherThread ? androidNativeOtherThreadAttachInfoList : otherThread);

    const newIndexToIsCollapsed = {};

    if (this.state.otherThreadFilterType === OTHER_THREAD_FILTER_TYPE_CONTAINS) {
      const lowerKeyword = keyword.toLowerCase();
      currentShowingThreadInfoList.forEach((thread, index) => {
        newIndexToIsCollapsed[index] = (thread.content || '').toLowerCase().includes(lowerKeyword);
      });
    } else if (this.state.otherThreadFilterType === OTHER_THREAD_FILTER_TYPE_REGEX) {
      try {
        const regexp = new RegExp(keyword, 'i');
        currentShowingThreadInfoList.forEach((thread, index) => {
          newIndexToIsCollapsed[index] = regexp.test(thread.content || '');
        });
      } catch (e) {
        message.error(ze('无效的正则表达式。', 'Invalid regexp.'));
        return;
      }
    }

    this.setState({
      otherThreadIndexToIsCollapsed: {
        ...this.state.otherThreadIndexToIsCollapsed,
        ...newIndexToIsCollapsed,
      },
    });
  }

  onClickExpandAllOtherThreads() {
    this.setState({
      otherThreadIndexToIsCollapsed: {},
    });
  }

  makeNoPermissionTabLabel(labelText) {
    const { t } = this.props;
    return <div>
      <Tooltip
        title={<div>
          <div>{t('common.当前用户角色缺少以下权限')}</div>
          <div>VIEW_PERSONAL_DATA</div>
        </div>}
      >{ labelText }<WrappedTipsIcon /></Tooltip></div>;
  }

  renderTabs(appId, pid, exceptionType, issue, crashDoc) {
    const { isIssueRegroup, t, reduxState } = this.props;
    const accountId = reduxState.app.get('current').get('accountId');
    const isNetmarble = accountId === '10050690181558001'; // 临时对netmarble账户下的所有项目，禁止FD信息tab

    const crashMap = (crashDoc || {}).crashMap || {};
    const { deviceId, bucketPath, expName } = crashMap;
    const esMap = (crashDoc || {}).esMap || {};
    let { moduleInfoCosKey, registerInfoCosKey, otherBreakpadCosKey, customCrashStack, gpuDumpInfoJson } = esMap;

    const attachName = crashDoc && crashDoc.detailMap && crashDoc.detailMap.attachName;

    const exceptionCategory = ExceptionCategoryUtil.unify(exceptionType);

    const isCategorySupportModuleTab = ExceptionCategoryUtil.isCrash(exceptionCategory)
      || ExceptionCategoryUtil.isHang(exceptionCategory)
      || (ExceptionCategoryUtil.isError(exceptionCategory) && this.getIsEnableErrorRetrace());

    const { crashLogData } = issue.get('appDetailCrashInfo') || {};

    // DFM项目逻辑比较特殊，需要从同session里面关联错误来展示breadcrumbs信息，所以只能用异常名带GPU来判断
    const hasGpuCrashInfo = this.getIsAssociateGpuCrashInfoWithError()
      ? ExceptionCategoryUtil.isCrash(exceptionCategory) && expName?.includes('GPU')
      : ExceptionCategoryUtil.isCrash(exceptionCategory) && (!!customCrashStack || !!gpuDumpInfoJson);

    let tabs = [{
      condition: true,
      value: 'LASTREPORT.errorStack',
    }, {
      condition: hasGpuCrashInfo,
      value: 'LASTREPORT.gpuStack'
    }, {
      condition: PlatformUtil.hasCrashAttachment(pid, exceptionCategory) || isPcOrLinux(pid),
      value: 'LASTREPORT.trackData',
    }, {
      condition: !isGameConsole(pid),
      value: 'LASTREPORT.trackLog',
    }, {
      condition: !isSwitch(pid),
      value: 'LASTREPORT.附件下载',
    }, {
      condition: !this.getIsFromShareLink(),
      value: 'LASTREPORT.symbol',
    }, {
      condition: (exceptionCategory === ExceptionCategory.CRASH || exceptionCategory === ExceptionCategory.HANG)
        && (PlatformUtil.isMobileOrMobileLike(pid) || isSwitch(pid) || !!registerInfoCosKey),
      value: 'LASTREPORT.崩溃线程寄存器信息',
    }, {
      condition: isCategorySupportModuleTab
        && (PlatformUtil.isMobileOrMobileLike(pid) || isSwitch(pid) || !!moduleInfoCosKey),
      value: 'LASTREPORT.加载模块信息',
    }, {
      condition: !isNetmarble && isAndroid(pid) && (exceptionCategory === ExceptionCategory.CRASH || exceptionCategory === ExceptionCategory.ERROR),
      value: 'LASTREPORT.FD信息',
    }, {
      condition: exceptionCategory === ExceptionCategory.ANR,
      value: 'LASTREPORT.anrMsg',
    }, {
      condition: exceptionCategory === ExceptionCategory.ANR,
      value: 'LASTREPORT.anrTrace',
    }, {
      condition: !!crashLogData,
      value: 'LASTREPORT.mallocLogger',
    }, {
      condition: !this.getIsFromShareLink(),
      value: 'LASTREPORT.sameDeviceRelatedReports',
    }].filter(x => x.condition);

    const requirePermissionTabs = ['LASTREPORT.trackData'];
    const hasPermission = this.hasViewPersonalDataPermission();
    const tabDetailList = tabs.map(x => ({
      key: x.value,
      noPermission: !hasPermission && requirePermissionTabs.includes(x),
    }));
    return (
      tabDetailList.length > 0 && <CsTabs
        bigSize={true}
        activeKey={issue.get('tab2') || tabDetailList[0].key}
        onChange={key => this.handleChangeTab(key)}
      >{
        tabDetailList.map(({ key, noPermission }) => <Tabs.TabPane
          tab={noPermission
            ? this.makeNoPermissionTabLabel(ix(t(key)))
            : ix(t(key))
          }
          disabled={noPermission}
          key={key}
        />)
      }</CsTabs>
    );
  }

  renderSameDeviceRelatedReports() {
    const {
      issue, appId, pid, issueId, exceptionType, isReport, isIssueRegroup, style, actions, path, crashDataType, t,
    } = this.props;

    const { crashDoc } = issue ? issue.toJS() : {};
    const crashMap = (crashDoc || {}).crashMap || {};
    const { deviceId, userId, crashId } = crashMap;

    // 更多上报把最近一次上报展开在 scroll.x=max-content 的表格里。同设备表的最小内容宽度
    // 会把这一行撑开，上面按 25% 排列的详情字段跟着变宽。收进父级宽度，表内自己横向滚动。
    return <div
      className={_style.data_container}
      style={{ fontSize: '14px', width: 0, minWidth: '100%', overflowX: 'auto' }}
    ><SameDeviceRelatedReports
      currentReportIssueId={issueId}
      currentReportCrashId={crashId}
      currentReportUserId={userId}
      currentReportDeviceId={deviceId}
      currentReportExceptionType={exceptionType}
      enableSameLaunchSessionFilter={this.getIsEnableSameLaunchSessionHint()}
      sessionScope={this.state.sameLaunchSessionScope}
      onSessionScopeChange={value => this.setState({ sameLaunchSessionScope: value })}
    /></div>;
  }

  hasViewPersonalDataPermission() {
    const { getHasSpecifiedPermission, shareLinkEquivalentUserPermissions } = this.props;
    return getHasSpecifiedPermission('VIEW_PERSONAL_DATA')
      || (this.getIsFromShareLink() && (shareLinkEquivalentUserPermissions || []).includes('VIEW_PERSONAL_DATA'));
  }

  hasAdminPermission() {
    const { getHasSpecifiedPermission, shareLinkEquivalentUserPermissions } = this.props;
    return getHasSpecifiedPermission('EDIT')
      || (this.getIsFromShareLink() && (shareLinkEquivalentUserPermissions || []).includes('EDIT'));
  }

  renderGenerateShareLinkModal() {
    const { t } = this.props;
    const {
      isGenerateShareLinkModalVisible,
      shareLinkExpireInDays,
      shareLinkUserRole,
    } = this.state;
    const expireInDaysRadioOptions = [3, 7, 15].map(x => <Radio value={x} key={x}>{ t('timePeriod.天', { day: x }) }</Radio>);
    const userRoleOptions = [
      { value: UserTypeEnum.STATS_VIEWER, label: t('LASTREPORT.与role一致', { role: t('MEMBERMANAGE.statsViewer') }) },
      this.hasViewPersonalDataPermission() && { value: UserTypeEnum.MEMBER, label: t('LASTREPORT.与role一致', { role: t('MEMBERMANAGE.normal') }) },
      !this.hasViewPersonalDataPermission() && { value: UserTypeEnum.COMPLIANCE_MEMBER, label: t('LASTREPORT.与role一致', { role: t('MEMBERMANAGE.complianceMember') }) },
    ].filter(x => x)
      .map(x => <Radio value={x.value} key={x.value}>{ x.label }</Radio>);

    return <Modal
      title={ t('LASTREPORT.生成匿名访问链接') }
      width={800}
      visible={isGenerateShareLinkModalVisible}
      onCancel={() => {
        this.setState({ isGenerateShareLinkModalVisible: false });
      }}
      okText={ t('LASTREPORT.生成匿名访问链接') }
      onOk={() => {
        this.setState({ isGenerateShareLinkModalVisible: false });
        this.generateReportShareLink();
        reportEvent({
          action: EVENT_ACTIONS.CLICK,
          tp1: '生成匿名链接',
        });
      }}
    >
      <div>{ t('LASTREPORT.generateShareLinkDesc') }</div>
      <Row style={{ marginTop: '24px' }} gutter={24}>
        <Col>{ t('LASTREPORT.链接有效期') }</Col>
        <Col>
          <Radio.Group
            value={shareLinkExpireInDays}
            onChange={e => this.setState({ shareLinkExpireInDays: e.target.value })}
          >
            { expireInDaysRadioOptions }
          </Radio.Group>
        </Col>
      </Row>
      {/*<Row style={{ marginTop: '24px' }} gutter={24}>
        <Col>
          <span>{ t('LASTREPORT.可查看信息范围') }</span>
          <span style={{ marginLeft: '8px' }}><Tooltip title={ t('LASTREPORT.可查看信息范围desc') }><InfoCircleOutlined style={{ color: '#999' }}/></Tooltip></span>
        </Col>
        <Col>
          <Radio.Group
            value={shareLinkUserRole}
            onChange={e => this.setState({ shareLinkUserRole: e.target.value })}
          >
            { userRoleOptions }
          </Radio.Group>
        </Col>
      </Row>*/}
    </Modal>;
  }

  renderIssueSendReportToWorkWeixinModal() {
    const { issue } = this.props;
    const { crashDoc } = issue ? issue.toJS() : {};

    return <IssueSendReportToWorkWeixinModal
      visible={this.state.isIssueSendReportToWorkWeixinModalVisible}
      onClose={() => this.setState({ isIssueSendReportToWorkWeixinModalVisible: false })}
      crashDoc={crashDoc}
    />;
  }

  renderSetQuickViewCustomKeyModal() {
    const { issue: currentIssue, appId, actions } = this.props;

    const options = (currentIssue.get('attachCustomKvList') || [])
      .map(x => ({ label: x.keyWithType, value: x.keyWithType }))
      .sort((a, b) => (a.value || '').localeCompare(b.value || ''));

    return <Modal
      title={ze('设置快捷展示字段', 'Set Quick View Fields')}
      visible={this.state.isSetQuickViewCustomKeyModalVisible}
      maskClosable={false}
      onCancel={() => this.setState({ isSetQuickViewCustomKeyModalVisible: false })}
      onOk={() => {
        this.setState({ isSetQuickViewCustomKeyModalVisible: false });
        actions.upsertWebAppSettings(appId, {
          [WebAppSettings.keys.QuickViewCustomKeyList]: this.state.editingQuickViewCustomKeyList,
        });
      }}
    >
      <div>
        <div>{ ze('设置了快捷展示的自定义字段将会直接展示在上报详情区域，无需进入跟踪数据查看。', 'Custom fields that are set up for quick view will be displayed directly in the report details area without having to go into the tracking data to view them.') }</div>
        <Divider/>
        <Select
          style={{ width: '100%' }}
          mode='multiple'
          options={options}
          value={this.state.editingQuickViewCustomKeyList}
          onChange={v => { this.setState({ editingQuickViewCustomKeyList: v }); }}
        />
      </div>
    </Modal>;
  }

  renderLogSymbolicateModal() {
    if (this.state.LogSymbolicateModalVisible) {
      return <StackSymbolicateModal
        modalProps={{
          visible: this.state.LogSymbolicateModalVisible,
          onOk: () => { this.setState({ LogSymbolicateModalVisible: false }) },
          onCancel: () => { this.setState({ LogSymbolicateModalVisible: false }) },
        }}
      />
    }
  }

  render() {
    if (this.state.componentHasError) {
      return <div>组件渲染时发生错误，请联系管理员</div>;
    }

    const {
      issue, appId, pid, issueId, exceptionType, isReport, isIssueRegroup, style, actions, path, crashDataType, t,
      shareId,
      shareLinkEquivalentUserPermissions,
    } = this.props;

    const isReportDetailCollapsed = this.state.isReportDetailCollapsed;

    const { crashDoc } = issue && issue.toJS();
    const { crashId } = crashDoc && crashDoc.crashMap || {};
    return (
      <div
        style={{ padding: '16px 24px' }}
        className={`${_style.issue_container} ${style.issue_container}`}
      >
        {
          this.renderTop(exceptionType, appId, pid, issueId, crashId, crashDataType)
        }
        { !isReportDetailCollapsed && <>
          <Divider style={{ margin: '14px 0 24px' }} />
          <ReportDetail
            style={{ padding: '0 16px' }}
            {...{
              appId, issue, pid, actions, path, exceptionType,
              shareId,
              shareLinkEquivalentUserPermissions,
              hasSdkScreenshot: this.state.hasSdkScreenshot,
            }} />

          { crashId && <Divider style={{ margin: '16px 0 ' }} /> }

          {
            crashId && this.renderTabs(appId, pid, exceptionType, issue, crashDoc)
          }

          {
            crashId && this.renderDataTab()
          }
          { this.renderGenerateShareLinkModal() }
          { this.renderIssueSendReportToWorkWeixinModal() }
          { this.renderSetQuickViewCustomKeyModal() }
          { this.renderLogSymbolicateModal() }
        </> }
      </div>
    );
  }
}

LastReport.propTypes = {
  style: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  issue: PropTypes.object,
  actions: PropTypes.object,
  crashHash: PropTypes.string,
  issueId: PropTypes.string,
  user: PropTypes.object,
  pid: PropTypes.string,
  appId: PropTypes.string,
  exceptionType: PropTypes.string,
  path: PropTypes.string,
  changeLog: PropTypes.func,
  changeLevel: PropTypes.func,
  changeLogKey: PropTypes.func,
  closeCrashItem: PropTypes.func,
  isReport: PropTypes.bool,  // true: 上报记录列表查看某个上报的界面  false: 问题详情下的最近一次上报/指定id上报界面
  // 表示是否是堆栈重分类界面嵌入的lastReport，这个界面嵌入的lastReport有些功能是不提供的，同时额外提供指定堆栈功能
  isIssueRegroup: PropTypes.bool,
  // 如果传了stackLineDetailObjectList，那么就直接用这个作为堆栈信息，不去从issue取数据了
  // 这个prop是给堆栈重分类用的
  stackLineDetailObjectList: PropTypes.array,
  getHasSpecifiedPermission: PropTypes.func,
  isLastReport: PropTypes.bool,
  shareId: PropTypes.string,  // 分享链接的id，如果不为空表示是通过分享链接查看的
  shareLinkEquivalentUserPermissions: PropTypes.array, // 分享链接的相关查看权限
};
